
// import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';

// const resources = {
//   en: {
//     translation: {
//       alt: {
//         companyLogo: 'Company Logo',
//         planBadge: 'Plan Badge',
//         notificationsIcon: 'Notifications Icon',
//         settings: 'Settings Icon',
//         event: 'Event Icon',
//         profile: 'Profile Icon',
//         application: 'Application Icon',
//         profilePicture: 'Profile Picture',
//         manageAccount: 'Manage Account Icon',
//         manageTeam: 'Manage Team Icon',
//         changePassword: 'Change Password Icon',
//         appPreview1: 'App Preview 1',
//         appPreview2: 'App Preview 2',
//         googlePlay: 'Google Play Store',
//         appStore: 'App Store',
//       },
//       search: {
//         placeholder: 'Search...',
//       },
//       notifications: {
//         title: 'Notifications',
//         settings: 'Settings Updated',
//         settingsUpdate: 'Your settings have been successfully updated.',
//         eventUpdate: 'Event Update',
//         eventUpdateDesc: 'New event scheduled for next week.',
//         profile: 'Profile Updated',
//         profileUpdate: 'Your profile information has been updated.',
//         applicationError: 'Application Error',
//         applicationErrorDesc: 'There was an error with your last application.',
//         seeAll: 'See All Notifications',
//       },
//       language: {
//         select: 'Select Language',
//       },
//       profile: {
//         dispatcherName: 'Dispatcher Name',
//         role: 'Role',
//         manageAccount: 'Manage Account',
//         manageTeam: 'Manage Team',
//         changePassword: 'Change Password',
//       },
//       profileManagement: {
//         title: 'Profile Management',
//         fullName: 'Full Name',
//         email: 'Email',
//         phone: 'Phone',
//         position: 'Position',
//         status: 'Status',
//         save: 'Save Changes',
//         saving: 'Saving...',
//         cancel: 'Cancel',
//       },
//       teamManagement: {
//         title: 'Team Management',
//         description: 'Add and manage your team members here.',
//         memberRole: 'Member Role',
//         selectRole: 'Select Role',
//         name: 'Name',
//         namePlaceholder: 'Enter full name',
//         email: 'Email',
//         emailPlaceholder: 'Enter email address',
//         addMember: 'Add Member',
//         adding: 'Adding...',
//         noMembers: 'No team members found.',
//         viewDashboard: 'View Dashboard',
//         roles: {
//           admin: 'Admin',
//           dispatcher: 'Dispatcher',
//           driver: 'Driver',
//         },
//       },
//       resetPassword: {
//         title: 'Reset Password',
//         description: 'Enter your new password below to reset it.',
//         password: 'New Password',
//         confirmPassword: 'Confirm New Password',
//         terms: 'I accept the terms and conditions',
//         save: 'Save Changes',
//         saving: 'Saving...',
//       },
//       success: {
//         title: 'Success',
//         profileUpdated: 'Profile updated successfully!',
//         passwordChanged: 'Password changed successfully!',
//         confirm: 'OK',
//       },
//       errors: {
//         requiredFields: 'Please fill in all required fields.',
//         updateProfileFailed: 'Failed to update profile. Please try again.',
//         passwordRequired: 'Both password fields are required.',
//         passwordMismatch: 'Passwords do not match.',
//         termsRequired: 'You must accept the terms and conditions.',
//         resetPasswordFailed: 'Failed to reset password. Please try again.',
//         fetchTeamFailed: 'Failed to fetch team members.',
//         refreshTeamFailed: 'Failed to refresh team members.',
//         addTeamFailed: 'Failed to add team member.',
//         fetchDashboardFailed: 'Failed to fetch dashboard data.',
//         fetchUsersFailed: 'Failed to fetch user data.',
//         fetchShipmentsFailed: 'Failed to fetch shipments.',
//         fetchShipmentDetailsFailed: 'Failed to fetch shipment details.',
//         error: 'Error: {{message}}',
//       },
//       sidebar: {

//          dashboard: '🏠 Dashboard',
//         orders: '📝 Orders & Containers',
//         dispatch: '🚚 Dispatch Management',
//         pod: '📄 Proof of Delivery (POD)',
//         invoices: '💳 Invoices & Payments',
//         reports: '📊 Reports',
//         drivers: '👥 Drivers & Fleet',
//         companyProfile: '🏢 Company Profile',
//         notifications: '🔔 Notifications & Alerts',
//         messages: '📩 Messages',
//         logout: '🚪 Logout',
//       },
//       dashboard: {
//         title: 'Dashboard',
//         inTransitContainers: 'In-Transit Containers',
//         totalContainers: 'Total Containers',
//         todaysDispatches: 'Today’s Dispatches',
//         pendingDeliveries: 'Pending Deliveries',
//         trackNow: 'Track Now',
//         viewAll: 'View All',
//         viewTrips: 'View Trips',
//         dispatch: 'Dispatch',
//         stayConnected: 'Stay Connected',
//         roadsideHelp: 'Roadside Help',
//         realTimeUpdates: 'Real-Time Updates',
//         proofOfDelivery: 'Proof of Delivery',
//         chatWithDispatchers: 'Chat with Dispatchers',
//         documentManagement: 'Document Management',
//         downloadApp: 'Download App',
//         liveContainer: 'Live Container Tracking',
//         shipmentId: 'Shipment ID: #{{id}}',
//         containerNo: 'Container No: {{number}}',
//         driverName: 'Driver Name: {{name}}',
//         view: 'View',
//         loading: 'Loading...',
//         loadingShipment: 'Loading shipment details...',
//         noUsersFound: 'No users found',
//         detailedContainerView: 'Detailed Container View',
//         shipmentOverview: 'Shipment Overview',
//         containerId: 'Container ID',
//         purchaseOrderNo: 'Purchase Order No.',
//         customerName: 'Customer Name',
//         numberOfPallets: 'Number of Pallets',
//         goodsType: 'Goods Type',
//         addedOn: 'Added On',
//         estimatedDeliveryDate: 'Estimated Delivery Date',
//         routeStatusTracking: 'Route & Status Tracking',
//         route: 'Route',
//         mapView: 'Map View: {{origin}} → {{destination}}',
//         trackContainer: 'Track Container',
//         currentStatus: 'Current Status',
//         driverAssignmentControl: 'Driver Assignment & Control',
//         assignedDriver: 'Assigned Driver',
//         vehicleNumber: 'Vehicle Number',
//         driverContact: 'Driver Contact',
//         call: 'Call',
//         message: 'Message',
//         markAsDelivered: 'Mark as Delivered',
//         saveUpdate: 'Save & Update',
//         fleetUserStatus: 'Fleet User Status',
//         driver: 'Driver',
//         currentTrip: 'Current Trip',
//         statusLabel: 'Status', // New key for the column header
//         status: 'Status',
//         nextAssignment: 'Next Assignment',
//         previous: 'Previous',
//         next: 'Next',
//         na: 'N/A',
//         status: {
//           approved: 'In Transit',
//           delivered: 'Delivered',
//           pending: 'Pending',
//           free: 'Free',
//         },
//         mapAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
//       },
//       fleet: {
//         noTrip: 'No Trip',
//         inTransit: 'In Transit',
//         delivered: 'Delivered',
//         pending: 'Pending',
//         free: 'Free',
//         noAssignment: 'No Assignment',
//       },
//       reports: {
//         dailyDispatch: 'Daily Dispatch Report',
//         monthlyContainer: 'Monthly Container Report',
//         routeOptimization: 'Route Optimization',
//         paymentSummary: 'Payment Summary',
//       },
//       orders: {
//         title: 'Orders & Containers Management',
//         filterBy: 'Filter By',
//         date: 'Date',
//         location: 'Location',
//         statusLabel: 'Status', // New key for table header and filter dropdown
//         status: {
//           pending: 'Pending',
//           inTransit: 'In Transit',
//           delivered: 'Delivered',
//         },
//         multipleDates: 'You can choose multiple dates',
//         apply: 'Apply',
//         multipleLocations: '*You can choose multiple Locations',
//         applyNow: 'Apply Now',
//         selectOrderStatus: 'Select Order Status',
//         multipleOrderStatus: '*You can choose multiple Order Status',
//         resetFilter: 'Reset Filter',
//         createNewDispatch: 'Create New Dispatch Order',
//         createNewContainer: '+ Create New Container',
//         import: 'Import',
//         export: 'Export',
//         dispatch: 'Dispatch',
//         orderId: 'Order ID',
//         orderIdPlaceholder: 'e.g., ORD123456',
//         origin: 'Origin',
//         originPlaceholder: 'e.g., Los Angeles, CA',
//         destination: 'Destination',
//         destinationPlaceholder: 'e.g., Houston, TX',
//         goodsDescription: 'Goods Description',
//         goodsDescriptionPlaceholder: 'e.g., Electronics shipment',
//         noOfPallets: 'Number of Pallets',
//         noOfPalletsPlaceholder: 'e.g., 10',
//         weightInTons: 'Weight (in Tons)',
//         weightInTonsPlaceholder: 'e.g., 5',
//         pricelabel: 'Pricing Details',
//         goodsType: 'Goods Type',
//         selectGoodsType: 'Select Goods Type',
//         goodsTypeOptions: {
//           electronics: 'Electronics',
//           textile: 'Textile',
//           food: 'Food',
//         },
//         pickUpDateTime: 'Pick Up Date/Time',
//         dropOffDateTime: 'Drop Off Date/Time',
//         pickUpHours: 'Pick Up Hours',
//         pickUpHoursPlaceholder: 'e.g., 09:00',
//         dropOffHours: 'Drop Off Hours',
//         dropOffHoursPlaceholder: 'e.g., 17:00',
//         containerDetails: 'Container Details',
//         containerType: 'Container Type',
//         containerTypePlaceholder: 'e.g., 40ft High Cube',
//         containerComments: 'Container Comments',
//         containerCommentsPlaceholder: 'e.g., Fragile items, handle with care',
//         containerNumber: 'Container Number',
//         containerNumberPlaceholder: 'e.g., CONT1234567',
//         length: 'Length',
//         lengthPlaceholder: 'e.g., 12m',
//         weight: 'Weight',
//         weightPlaceholder: 'e.g., 1000kg',
//         commodity: 'Commodity',
//         commodityPlaceholder: 'e.g., Laptops',
//         routeDeliveryInfo: 'Route & Delivery Info',
//         intermediateStop: 'Intermediate Stop {{index}}',
//         intermediateStopPlaceholder: 'e.g., Phoenix, AZ',
//         addIntermediateStop: '+ Add Intermediate Stop',
//         terminal: 'Terminal',
//         terminalPlaceholder: 'e.g., Terminal A',
//         routeNotes: 'Route Notes',
//         routeNotesPlaceholder: 'e.g., Route via I-10',
//         driverAssignment: 'Driver Assignment',
//         assignedDriver: 'Assigned Driver',
//         selectDriver: 'Select Driver',
//         searchDriverPlaceholder: 'Search driver name or ID',
//         loadingDrivers: 'Loading drivers...',
//         noDriverFound: 'No driver found',
//         vehicleNumber: 'Vehicle Number',
//         vehicleNumberPlaceholder: 'e.g., TX1234XYZ',
//         driverContact: 'Driver Contact',
//         driverContactPlaceholder: 'e.g., +15556667777',
//         addedOn: 'Added On',
//         estimatedDeliveryDate: 'Estimated Delivery Date',
//         portDetails: 'Port Details',
//         portName: 'Port Name',
//         portNamePlaceholder: 'e.g., Port of LA',
//         ticketNumber: 'Ticket/PIN Number',
//         ticketNumberPlaceholder: 'e.g., TICKET987654',
//         bookingNumber: 'Booking Number',
//         bookingNumberPlaceholder: 'e.g., BOOK1234567890',
//         price: 'Price',
//         pricePlaceholder: 'e.g., 1200',
//         selectStatus: 'Select Status',
//         assign: 'Assign',
//         assigned: 'Assigned',
//         successfully: 'Successfully',
//         successMessage: 'Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.',
//         ok: 'OK',
//         containerId: 'Container ID',
//         containerIdPlaceholder: 'Enter Container ID',
//         purchaseOrderNo: 'Purchase Order No.',
//         originDestination: 'Origin → Destination',
//         importExportType: {
//           import: 'Import',
//           export: 'Export',
//           dispatch: 'Dispatch',
//         },
//         eta: 'ETA',
//         etaPlaceholder: 'Enter ETA (e.g., 3 days)',
//         actions: 'Actions',
//         view: 'View',
//         showing: 'Showing {{start}}-{{end}} of {{total}}',
//         previous: 'Previous',
//         next: 'Next',
//         noShipmentsFound: 'No shipments found',
//         detailedContainerView: 'Detailed Container View',
//         shipmentOverview: 'Shipment Overview',
//         stopsList: 'Stops List',
//         stopsListPlaceholder: 'Enter stops as: City - MM/DD/YYYY, HH:MM:SS AM/PM (one per line)',
//         driverAssignmentControl: 'Driver Assignment & Control',
//         store: 'Store',
//         storePlaceholder: 'Enter Store',
//         update: 'Update',
//         loading: 'Loading...',
//         na: 'N/A',
//         errors: {
//           requiredField: 'Please fill in the {{field}} field',
//           invalidStopFormat: 'Invalid format for intermediate destinations. Use: City - MM/DD/YYYY, HH:MM:SS AM/PM',
//           unexpectedApiResponse: 'Unexpected API response structure: No valid docs array found',
//           fetchDriversFailed: 'Failed to load drivers: {{message}}',
//           noDriversFound: 'No drivers found with userType: DRIVER',
//           createShipmentFailed: 'Failed to create shipment',
//           fetchShipmentsFailed: 'Failed to fetch shipments',
//           fetchShipmentDetailsFailed: 'Failed to load shipment details',
//           error: 'Error: {{message}}',
//         },
//         alt: {
//           driverAvatar: 'Driver Avatar',
//           checkmark: 'Checkmark',
//         },
//       },
//     },
//   },
//   es: {
//     translation: {
//       alt: {
//         companyLogo: 'Logotipo de la Empresa',
//         planBadge: 'Insignia del Plan',
//         notificationsIcon: 'Ícono de Notificaciones',
//         settings: 'Ícono de Configuraciones',
//         event: 'Ícono de Evento',
//         profile: 'Ícono de Perfil',
//         application: 'Ícono de Aplicación',
//         profilePicture: 'Foto de Perfil',
//         manageAccount: 'Ícono de Gestionar Cuenta',
//         manageTeam: 'Ícono de Gestionar Equipo',
//         changePassword: 'Ícono de Cambiar Contraseña',
//         appPreview1: 'Vista Previa de la Aplicación 1',
//         appPreview2: 'Vista Previa de la Aplicación 2',
//         googlePlay: 'Google Play Store',
//         appStore: 'App Store',
//       },
//       search: {
//         placeholder: 'Buscar...',
//       },
//       notifications: {
//         title: 'Notificaciones',
//         settings: 'Configuraciones Actualizadas',
//         settingsUpdate: 'Tus configuraciones han sido actualizadas con éxito.',
//         eventUpdate: 'Actualización de Evento',
//         eventUpdateDesc: 'Nuevo evento programado para la próxima semana.',
//         profile: 'Perfil Actualizado',
//         profileUpdate: 'La información de tu perfil ha sido actualizada.',
//         applicationError: 'Error de Aplicación',
//         applicationErrorDesc: 'Hubo un error con tu última aplicación.',
//         seeAll: 'Ver Todas las Notificaciones',
//       },
//       language: {
//         select: 'Seleccionar Idioma',
//       },
//       profile: {
//         dispatcherName: 'Nombre del Despachador',
//         role: 'Rol',
//         manageAccount: 'Gestionar Cuenta',
//         manageTeam: 'Gestionar Equipo',
//         changePassword: 'Cambiar Contraseña',
//       },
//       profileManagement: {
//         title: 'Gestión de Perfil',
//         fullName: 'Nombre Completo',
//         email: 'Correo Electrónico',
//         phone: 'Teléfono',
//         position: 'Posición',
//         status: 'Estado',
//         save: 'Guardar Cambios',
//         saving: 'Guardando...',
//         cancel: 'Cancelar',
//       },
//       teamManagement: {
//         title: 'Gestión de Equipo',
//         description: 'Añade y gestiona a los miembros de tu equipo aquí.',
//         memberRole: 'Rol del Miembro',
//         selectRole: 'Seleccionar Rol',
//         name: 'Nombre',
//         namePlaceholder: 'Ingresar nombre completo',
//         email: 'Correo Electrónico',
//         emailPlaceholder: 'Ingresar dirección de correo electrónico',
//         addMember: 'Añadir Miembro',
//         adding: 'Añadiendo...',
//         noMembers: 'No se encontraron miembros del equipo.',
//         viewDashboard: 'Ver Tablero',
//         roles: {
//           admin: 'Administrador',
//           dispatcher: 'Despachador',
//           driver: 'Conductor',
//         },
//       },
//       resetPassword: {
//         title: 'Restablecer Contraseña',
//         description: 'Ingresa tu nueva contraseña a continuación para restablecerla.',
//         password: 'Nueva Contraseña',
//         confirmPassword: 'Confirmar Nueva Contraseña',
//         terms: 'Acepto los términos y condiciones',
//         save: 'Guardar Cambios',
//         saving: 'Guardando...',
//       },
//       success: {
//         title: 'Éxito',
//         profileUpdated: '¡Perfil actualizado con éxito!',
//         passwordChanged: '¡Contraseña cambiada con éxito!',
//         confirm: 'Aceptar',
//       },
//       errors: {
//         requiredFields: 'Por favor completa todos los campos obligatorios.',
//         updateProfileFailed: 'No se pudo actualizar el perfil. Por favor intenta de nuevo.',
//         passwordRequired: 'Ambos campos de contraseña son obligatorios.',
//         passwordMismatch: 'Las contraseñas no coinciden.',
//         termsRequired: 'Debes aceptar los términos y condiciones.',
//         resetPasswordFailed: 'No se pudo restablecer la contraseña. Por favor intenta de nuevo.',
//         fetchTeamFailed: 'No se pudieron obtener los miembros del equipo.',
//         refreshTeamFailed: 'No se pudieron actualizar los miembros del equipo.',
//         addTeamFailed: 'No se pudo añadir al miembro del equipo.',
//         fetchDashboardFailed: 'No se pudieron obtener los datos del tablero.',
//         fetchUsersFailed: 'No se pudieron obtener los datos de los usuarios.',
//         fetchShipmentsFailed: 'No se pudieron obtener los envíos.',
//         fetchShipmentDetailsFailed: 'No se pudieron obtener los detalles del envío.',
//         error: 'Error: {{message}}',
//       },
//       sidebar: {
//         dashboard: '🏠 Tablero',
//         orders: '📝 Pedidos y Contenedores',
//         dispatch: '🚚 Gestión de Despacho',
//         pod: '📄 Prueba de Entrega (POD)',
//         invoices: '💳 Facturas y Pagos',
//         reports: '📊 Informes',
//         drivers: '👥 Conductores y Flota',
//         companyProfile: '🏢 Perfil de la Empresa',
//         notifications: '🔔 Notificaciones y Alertas',
//         messages: '📩 Mensajes',
//         logout: '🚪 Cerrar Sesión',
//       },
//       dashboard: {
//         title: 'Tablero',
//         inTransitContainers: 'Contenedores en Tránsito',
//         totalContainers: 'Total de Contenedores',
//         todaysDispatches: 'Despachos de Hoy',
//         pendingDeliveries: 'Entregas Pendientes',
//         trackNow: 'Rastrear Ahora',
//         viewAll: 'Ver Todo',
//         viewTrips: 'Ver Viajes',
//         dispatch: 'Despachar',
//         stayConnected: 'Mantente Conectado',
//         roadsideHelp: 'Asistencia en Carretera',
//         realTimeUpdates: 'Actualizaciones en Tiempo Real',
//         proofOfDelivery: 'Prueba de Entrega',
//         chatWithDispatchers: 'Chatear con Despachadores',
//         documentManagement: 'Gestión de Documentos',
//         downloadApp: 'Descargar Aplicación',
//         liveContainer: 'Seguimiento de Contenedores en Vivo',
//         shipmentId: 'ID de Envío: #{{id}}',
//         containerNo: 'No. de Contenedor: {{number}}',
//         driverName: 'Nombre del Conductor: {{name}}',
//         view: 'Ver',
//         loading: 'Cargando...',
//         loadingShipment: 'Cargando detalles del envío...',
//         noUsersFound: 'No se encontraron usuarios',
//         detailedContainerView: 'Vista Detallada del Contenedor',
//         shipmentOverview: 'Resumen del Envío',
//         containerId: 'ID del Contenedor',
//         purchaseOrderNo: 'No. de Orden de Compra',
//         customerName: 'Nombre del Cliente',
//         numberOfPallets: 'Número de Palets',
//         goodsType: 'Tipo de Mercancías',
//         addedOn: 'Añadido el',
//         estimatedDeliveryDate: 'Fecha de Entrega Estimada',
//         routeStatusTracking: 'Ruta y Seguimiento de Estado',
//         route: 'Ruta',
//         mapView: 'Vista del Mapa: {{origin}} → {{destination}}',
//         trackContainer: 'Rastrear Contenedor',
//         currentStatus: 'Estado Actual',
//         driverAssignmentControl: 'Asignación y Control de Conductores',
//         assignedDriver: 'Conductor Asignado',
//         vehicleNumber: 'Número del Vehículo',
//         driverContact: 'Contacto del Conductor',
//         call: 'Llamar',
//         message: 'Mensaje',
//         markAsDelivered: 'Marcar como Entregado',
//         saveUpdate: 'Guardar y Actualizar',
//         fleetUserStatus: 'Estado de los Usuarios de la Flota',
//         driver: 'Conductor',
//         currentTrip: 'Viaje Actual',
//         statusLabel: 'Estado', // New key for the column header
//         status: 'Estado',
//         nextAssignment: 'Próxima Asignación',
//         previous: 'Anterior',
//         next: 'Siguiente',
//         na: 'N/D',
//         status: {
//           approved: 'En Tránsito',
//           delivered: 'Entregado',
//           pending: 'Pendiente',
//           free: 'Libre',
//         },
//         mapAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contribuyentes',
//       },
//       fleet: {
//         noTrip: 'Sin Viaje',
//         inTransit: 'En Tránsito',
//         delivered: 'Entregado',
//         pending: 'Pendiente',
//         free: 'Libre',
//         noAssignment: 'Sin Asignación',
//       },
//       reports: {
//         dailyDispatch: 'Informe de Despacho Diario',
//         monthlyContainer: 'Informe Mensual de Contenedores',
//         routeOptimization: 'Optimización de Rutas',
//         paymentSummary: 'Resumen de Pagos',
//       },
//       orders: {
//         title: 'Gestión de Órdenes y Contenedores',
//         filterBy: 'Filtrar Por',
//         date: 'Fecha',
//         location: 'Ubicación',
//         statusLabel: 'Estado', // New key for table header and filter dropdown
//         status: {
//           pending: 'Pendiente',
//           inTransit: 'En Tránsito',
//           delivered: 'Entregado',
//         },
//         multipleDates: 'Puedes elegir múltiples fechas',
//         apply: 'Aplicar',
//         multipleLocations: '*Puedes elegir múltiples ubicaciones',
//         applyNow: 'Aplicar Ahora',
//         selectOrderStatus: 'Seleccionar Estado de la Orden',
//         multipleOrderStatus: '*Puedes elegir múltiples estados de orden',
//         resetFilter: 'Restablecer Filtro',
//         createNewDispatch: 'Crear Nueva Orden de Despacho',
//         createNewContainer: '+ Crear Nuevo Contenedor',
//         import: 'Importar',
//         export: 'Exportar',
//         dispatch: 'Despacho',
//         orderId: 'ID de Orden',
//         orderIdPlaceholder: 'p.ej., ORD123456',
//         origin: 'Origen',
//         originPlaceholder: 'p.ej., Los Ángeles, CA',
//         destination: 'Destino',
//         destinationPlaceholder: 'p.ej., Houston, TX',
//         goodsDescription: 'Descripción de Mercancías',
//         goodsDescriptionPlaceholder: 'p.ej., Envío de electrónicos',
//         noOfPallets: 'Número de Palets',
//         noOfPalletsPlaceholder: 'p.ej., 10',
//              pricelabel: 'Detalles de precios',
//         weightInTons: 'Peso (en Toneladas)',
//         weightInTonsPlaceholder: 'p.ej., 5',
//         goodsType: 'Tipo de Mercancías',
//         selectGoodsType: 'Seleccionar Tipo de Mercancías',
//         goodsTypeOptions: {
//           electronics: 'Electrónicos',
//           textile: 'Textiles',
//           food: 'Alimentos',
//         },
//         pickUpDateTime: 'Fecha/Hora de Recogida',
//         dropOffDateTime: 'Fecha/Hora de Entrega',
//         pickUpHours: 'Horas de Recogida',
//         pickUpHoursPlaceholder: 'p.ej., 09:00',
//         dropOffHours: 'Horas de Entrega',
//         dropOffHoursPlaceholder: 'p.ej., 17:00',
//         containerDetails: 'Detalles del Contenedor',
//         containerType: 'Tipo de Contenedor',
//         containerTypePlaceholder: 'p.ej., Cubo Alto de 40 pies',
//         containerComments: 'Comentarios del Contenedor',
//         containerCommentsPlaceholder: 'p.ej., Artículos frágiles, manejar con cuidado',
//         containerNumber: 'Número de Contenedor',
//         containerNumberPlaceholder: 'p.ej., CONT1234567',
//         length: 'Longitud',
//         lengthPlaceholder: 'p.ej., 12m',
//         weight: 'Peso',
//         weightPlaceholder: 'p.ej., 1000kg',
//         commodity: 'Mercancía',
//         commodityPlaceholder: 'p.ej., Portátiles',
//         routeDeliveryInfo: 'Ruta e Información de Entrega',
//         intermediateStop: 'Parada Intermedia {{index}}',
//         intermediateStopPlaceholder: 'p.ej., Phoenix, AZ',
//         addIntermediateStop: '+ Añadir Parada Intermedia',
//         terminal: 'Terminal',
//         terminalPlaceholder: 'p.ej., Terminal A',
//         routeNotes: 'Notas de Ruta',
//         routeNotesPlaceholder: 'p.ej., Ruta vía I-10',
//         driverAssignment: 'Asignación de Conductor',
//         assignedDriver: 'Conductor Asignado',
//         selectDriver: 'Seleccionar Conductor',
//         searchDriverPlaceholder: 'Buscar nombre o ID del conductor',
//         loadingDrivers: 'Cargando conductores...',
//         noDriverFound: 'No se encontró conductor',
//         vehicleNumber: 'Número de Vehículo',
//         vehicleNumberPlaceholder: 'p.ej., TX1234XYZ',
//         driverContact: 'Contacto del Conductor',
//         driverContactPlaceholder: 'p.ej., +15556667777',
//         addedOn: 'Añadido el',
//         estimatedDeliveryDate: 'Fecha de Entrega Estimada',
//         portDetails: 'Detalles del Puerto',
//         portName: 'Nombre del Puerto',
//         portNamePlaceholder: 'p.ej., Puerto de LA',
//         ticketNumber: 'Número de Ticket/PIN',
//         ticketNumberPlaceholder: 'p.ej., TICKET987654',
//         bookingNumber: 'Número de Reserva',
//         bookingNumberPlaceholder: 'p.ej., BOOK1234567890',
//         price: 'Precio',
//         pricePlaceholder: 'p.ej., 1200',
//         selectStatus: 'Seleccionar Estado',
//         assign: 'Asignar',
//         assigned: 'Asignado',
//         successfully: 'Exitosamente',
//         successMessage: 'Lorem ipsum es un texto de relleno comúnmente usado en las industrias gráfica, de impresión y publicación para previsualizar diseños y maquetas visuales.',
//         ok: 'Aceptar',
//         containerId: 'ID del Contenedor',
//         containerIdPlaceholder: 'Ingresar ID del Contenedor',
//         purchaseOrderNo: 'No. de Orden de Compra',
//         originDestination: 'Origen → Destino',
//         importExportType: {
//           import: 'Importar',
//           export: 'Exportar',
//           disptach: 'Despacho', // Corrected typo
//         },
//         eta: 'ETA',
//         etaPlaceholder: 'Ingresar ETA (p.ej., 3 días)',
//         actions: 'Acciones',
//         view: 'Ver',
//         showing: 'Mostrando {{start}}-{{end}} de {{total}}',
//         previous: 'Anterior',
//         next: 'Siguiente',
//         noShipmentsFound: 'No se encontraron envíos',
//         detailedContainerView: 'Vista Detallada del Contenedor',
//         shipmentOverview: 'Resumen del Envío',
//         stopsList: 'Lista de Paradas',
//         stopsListPlaceholder: 'Ingresar paradas como: Ciudad - DD/MM/AAAA, HH:MM:SS (una por línea)',
//         driverAssignmentControl: 'Asignación y Control de Conductores',
//         store: 'Tienda',
//         storePlaceholder: 'Ingresar Tienda',
//         update: 'Actualizar',
//         loading: 'Cargando...',
//         na: 'N/D',
//         errors: {
//           requiredField: 'Por favor completa el campo {{field}}',
//           invalidStopFormat: 'Formato inválido para destinos intermedios. Usa: Ciudad - DD/MM/AAAA, HH:MM:SS',
//           unexpectedApiResponse: 'Estructura de respuesta de API inesperada: No se encontró un arreglo de documentos válido',
//           fetchDriversFailed: 'No se pudieron cargar los conductores: {{message}}',
//           noDriversFound: 'No se encontraron conductores con userType: DRIVER',
//           createShipmentFailed: 'No se pudo crear el envío',
//           fetchShipmentsFailed: 'No se pudieron obtener los envíos',
//           fetchShipmentDetailsFailed: 'No se pudieron cargar los detalles del envío',
//           error: 'Error: {{message}}',
//         },
//         alt: {
//           driverAvatar: 'Avatar del Conductor',
//           checkmark: 'Marca de Verificación',
//         },
//       },
//     },
//   },
// };

// i18n
//   .use(initReactI18next)
//   .init({
//     resources,
//     lng: 'en', // Default language
//     fallbackLng: 'en',
//     interpolation: {
//       escapeValue: false, // React already escapes by default
//     },
//   });

// export default i18n;
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {

      "client": {
        "title": "Client Management",
        "addButton": "Add Client",
        "addTitle": "Add New Client",
        "submit": "Save",
        "table": {
          "name": "Name",
          "email": "Email",
          "phone": "Phone",
          "company": "Company"
        }
      }
      ,

      companyProfile: {
        title: "Company Profile",
        loading: "Loading company profile...",
        error: "Failed to load your profile. Please try refreshing the page.",
        tabs: {
          companyDetails: "Company Details",
          contactAddress: "Contact & Address",
          legalDocs: "Legal & Registration Documents",
          subscription: "Subscription Overview"
        }
      },
      companyDetails: {
        companyName: "Company Name",
        website: "Website (if applicable)",
        websitePlaceholder: "Website URL",
        companyId: "Company ID (Auto-generated)",
        industryType: "Industry Type",
        industryTypePlaceholder: "Logistics",
        establishedYear: "Established Year",
        description: "Description / About",
        descriptionPlaceholder: "Brief company summary (max. 500 characters)"
      },
      contactAddress: {
        officialEmail: "Official Email",
        supportContact: "Support Contact Number",
        officeAddress: "Office Address Details",
        country: "Country",
        city: "City",
        zipCode: "Zip Code",
        timeZone: "Time Zone"
      },
      legalDocs: {
        regNo: "Company Registration Number",
        regNoPlaceholder: "Company Registration Number",
        gstVat: "GST / VAT Number",
        gstVatPlaceholder: "GST / VAT Number",
        uploadLicense: "Upload Company License*",
        uploadTaxDoc: "Tax Registration Document*",
        uploadInsurance: "Business Insurance Proof*",
        changeFile: "Change PDF/Image",
        uploadFile: "Upload PDF/Image"
      },
      subscription: {
        title: "Subscription Overview",
        currentPlan: "Current Plan:",
        status: "Status:",
        nextBilling: "Next Billing:",
        paymentMethod: "Payment Method:",
        pricePerYear: "/Month",
        upgradePlan: "Upgrade Plan",
        cancelPlan: "Cancel Subscription",

        // New keys for cancellation confirmation
        cancelConfirmationTitle: "Are you sure?",
        cancelConfirmationText: "Do you really want to cancel your {{plan}}? MemberShip",
        yesCancel: "Yes, cancel it!",
        noKeep: "No, keep it",
        cancelled: "Cancelled",
        cancelSuccess: "Your {{plan}} has been cancelled.",
        error: "Error",
        cancelError: "Something went wrong while cancelling.",
        stillActive: "Your subscription is still active 🙂"
      },

      status: {
        Active: "Active",
        Inactive: "Inactive",
        Pending: "Pending"
      },
      common: {
        saveChanges: "Save Changes",
        notAvailable: "Not Available",
        loading: "Loading...",
        unknown: "Unknown"
      }
      ,

      notification: {
        title: 'Notifications & Alerts',
        buttons: {
          push: 'Send Notification',
          submit: 'Submit',
          ok: 'OK',
          view: 'View'
        },
        table: {
          header: {
            templateName: 'Template Name',
            channel: 'Channel',
            date: 'Date',
            type: 'Type'
          },
          body: {
            specificUser: 'Specific User',
            allChannels: 'All Channels',
            noData: 'No notifications found.',
            showing: 'Showing 1-{{count}} of {{total}}'
          }
        },
        modal: {
          createTitle: 'Send Notification',
          detailsTitle: 'Notification Details',
          form: {
            titleLabel: 'Notification Title',
            titlePlaceholder: 'Enter notification title',
            descLabel: 'Notification Description',
            descPlaceholder: 'Enter notification description',
            typeLabel: 'Notification Type',
            typeSelect: 'Select notification type',
            typeOptions: {
              ETA_UPDATE: 'ETA Updates for Customers',
              DELAY: 'Notify Delays',
              DELIVERY_CONFIRMATION: 'Container Delivery Confirmation',
              PAYMENT_REMINDER: 'Overdue Payment Reminders',
              OTHER: 'Other'
            },
            dateLabel: 'Until Date',
            datePlaceholder: 'September 11, 2025',
            driverLabel: 'Driver Name (if specific)',
            driverPlaceholder: 'Enter driver ID',
            sendToAll: 'Send to All Drivers'
          }
        },
        success: {
          title: 'Notification Sent Successfully',
          highlight: 'Sent Successfully',
          message: 'The notification has been successfully sent to the selected recipients.'
        },
        viewDetails: {
          description: 'Description',
          recipient: 'Recipient',
          recipientAll: 'All Drivers',
          createdAt: 'Created At'
        },
        errors: {
          fetch: 'Failed to load notifications. Please try refreshing the page.'
        }
      }
      ,

      alt: {
        companyLogo: 'Company Logo',
        planBadge: 'Plan Badge',
        notificationsIcon: 'Notifications Icon',
        settings: 'Settings Icon',
        event: 'Event Icon',
        profile: 'Profile Icon',
        application: 'Application Icon',
        profilePicture: 'Profile Picture',
        manageAccount: 'Manage Account Icon',
        manageTeam: 'Manage Team Icon',
        changePassword: 'Change Password Icon',
        appPreview1: 'App Preview 1',
        appPreview2: 'App Preview 2',
        googlePlay: 'Google Play Store',
        appStore: 'App Store',
        driverAvatar: 'Driver Avatar',
        checkmark: 'Checkmark',
        closeLTLModal: 'Close LTL Modal',
        closeFTLModal: 'Close FTL Modal',
        createLTLDispatch: 'Create LTL Shipment Button', // Updated: "Dispatch" to "Shipment"
        createFTLDispatch: 'Create FTL Shipment Button', // Updated: "Dispatch" to "Shipment"
        addStop: 'Add Stop Button',
        removeStop: 'Remove Stop Button',
        viewShipment: 'View Shipment {{id}}',
        closePODModal: 'Close POD Modal',
        closeRequestModal: 'Close Request Modal',
        containerImage: 'Container Image {{index}}',
        cargoImage: 'Cargo Image {{index}}',
        deliverySiteImage: 'Delivery Site Image {{index}}',
        podDocument: 'POD Document {{index}}',
      },
      search: {
        placeholder: 'Search...',
      },
      notifications: {
        title: 'Notifications',
        settings: 'Settings Updated',
        settingsUpdate: 'Your settings have been successfully updated.',
        eventUpdate: 'Event Update',
        eventUpdateDesc: 'New event scheduled for next week.',
        profile: 'Profile Updated',
        profileUpdate: 'Your profile information has been updated.',
        applicationError: 'Application Error',
        applicationErrorDesc: 'There was an error with your last application.',
        seeAll: 'See All Notifications',
      },
      language: {
        select: 'Select Language',
      },
      profile: {
        dispatcherName: 'Shipment Manager Name', // Updated: "Dispatcher" to "Shipment Manager"
        role: 'Role',
        manageAccount: 'Manage Account',
        manageTeam: 'Manage Team',
        changePassword: 'Change Password',
      },
      profileManagement: {
        title: 'Profile Management',
        fullName: 'Full Name',
        email: 'Email',
        phone: 'Phone',
        position: 'Position',
        status: 'Status',
        save: 'Save Changes',
        saving: 'Saving...',
        cancel: 'Cancel',
      },
      teamManagement: {
        title: 'Team Management',
        description: 'Add and manage your team members here.',
        memberRole: 'Member Role',
        selectRole: 'Select Role',
        name: 'Name',
        namePlaceholder: 'Enter full name',
        email: 'Email',
        emailPlaceholder: 'Enter email address',
        addMember: 'Add Member',
        adding: 'Adding...',
        noMembers: 'No team members found.',
        viewDashboard: 'View Dashboard',
        roles: {
          admin: 'Admin',
          dispatcher: 'Shipment Manager', // Updated: "Dispatcher" to "Shipment Manager"
          driver: 'Driver',
        },
      },
      resetPassword: {
        title: 'Reset Password',
        description: 'Enter your new password below to reset it.',
        password: 'New Password',
        confirmPassword: 'Confirm New Password',
        terms: 'I accept the terms and conditions',
        save: 'Save Changes',
        saving: 'Saving...',
      },
      success: {
        title: 'Success',
        profileUpdated: 'Profile updated successfully!',
        passwordChanged: 'Password changed successfully!',
        confirm: 'OK',
      },
      errors: {
        requiredFields: 'Please fill in all required fields.',
        updateProfileFailed: 'Failed to update profile. Please try again.',
        passwordRequired: 'Both password fields are required.',
        passwordMismatch: 'Passwords do not match.',
        termsRequired: 'You must accept the terms and conditions.',
        resetPasswordFailed: 'Failed to reset password. Please try again.',
        fetchTeamFailed: 'Failed to fetch team members.',
        refreshTeamFailed: 'Failed to refresh team members.',
        addTeamFailed: 'Failed to add team member.',
        fetchDashboardFailed: 'Failed to fetch dashboard data.',
        fetchUsersFailed: 'Failed to fetch user data.',
        fetchShipmentsFailed: 'Failed to fetch shipments.',
        fetchShipmentDetailsFailed: 'Failed to fetch shipment details.',
        error: 'Info',
        selectDispatchType: 'Please select a dispatch type',
        selectContainer: 'Select Container',
        fetchVehiclesFailed: 'Failed to fetch vehicles',
        fetchDriversFailed: 'Failed to fetch drivers',
        addDriverFailed: 'Failed to add driver'

      },
    sidebar: {
  dashboard: '🏠 Dashboard',
  orders: '📝 Orders & Containers',
  exportContainer:"📦 Export Container",
  loads: '🚛 LTL/FTL Loads',
  dispatch: '🚚 Dispatch Management',
  pod: '📄 Proof of Delivery (POD)',
  invoices: '💳 Invoices & Payments',
  reports: '📊 Reports',
  incidentReport: '⚠️ Incident Report',
  drivers: '👥 Drivers & Fleet',
  clientManagement: '🤝 Client Management',
  companyProfile: '🏢 Company Profile',
  notifications: '🔔 Notifications & Alerts',
  messages: '📩 Messages',
  dispatcherLinks: '🔗 Dispatcher Links',
  logout: '🚪 Logout',
}
,



  "linkData": {
    "title": "Link Data List",
    "table": {
      "header": {
        "name": "Link Name",
        "url": "URL Address"
      },
      "body": {
        "noData": "No link data found.",
        "showing": "Showing {{count}} of {{total}} items"
      }
    },
    "pagination": {
      "previous": "Previous",
      "next": "Next",
      "pageOf": "Page {{current}} of {{total}}"
    },
    "messages": {
      "errorFetch": "Could not load link data."
    }
  },

      dashboard: {
        title: 'Dashboard',
        inTransitContainers: 'In-Transit Containers',
        totalContainers: 'Total Containers',
        stopsList: 'Stops List',

        todaysDispatches: 'Today’s Shipments', // Updated: "Dispatches" to "Shipments"
        pendingDeliveries: 'Pending Deliveries',
        totalDispatched: 'Total Dispatched',
        liveRouteMonitoring: 'Live Route Monitoring',
        statusUpdates: 'Status Updates',
        totalPending: 'Total Pending',
        routeNotes: 'Route Notes',
        selectContainer: 'Select Container',

        autoAssignDescription: 'Auto-assign drivers and notify both parties',
        automaticAssignment: 'Automatic Assignement',
        availableDrivers: 'Available Drivers',
        selectDriverPlaceholder: 'Select Driver Name or ID',

        totalInTransit: 'Total In Transit',
        totalDelivered: 'Total Delivered',
        trackNow: 'Track Now',
        viewAll: 'View All',
        dispatchManagement: 'Dispatch Management',
        viewTrips: 'View Trips',
        dispatch: 'Create Shipment', // Updated: "Dispatch" to "Create Shipment"
        stayConnected: 'Stay Connected',
        roadsideHelp: 'Roadside Help',
        realTimeUpdates: 'Real-Time Updates',
        proofOfDelivery: 'Proof of Delivery',
        chatWithDispatchers: 'Chat with Shipment Managers', // Updated: "Dispatchers" to "Shipment Managers"
        documentManagement: 'Document Management',
        downloadApp: 'Download App',
        dispatchAssignment: 'Dispatch Assignment',
        liveContainer: 'Live Container Tracking',
        shipmentId: 'Shipment ID: #{{id}}', // Updated: "Shipment" for consistency
        containerNo: 'Container No: {{number}}',
        driverName: 'Driver Name: {{name}}',
        view: 'View',
        loading: 'Loading...',
        loadingShipment: 'Loading shipment details...',
        noUsersFound: 'No users found',
        detailedContainerView: 'Detailed Container View',
        shipmentOverview: 'Shipment Overview', // Updated: "Shipment" for consistency
        containerId: 'Container ID',
        purchaseOrderNo: 'Purchase Order No.',
        customerName: 'Customer Name',
        numberOfPallets: 'Number of Pallets',
        goodsType: 'Goods Type',
        addedOn: 'Added On',
        estimatedDeliveryDate: 'Estimated Delivery Date',
        routeStatusTracking: 'Route & Status Tracking',
        route: 'Route',
        mapView: 'Map View: {{origin}} → {{destination}}',
        trackContainer: 'Track Container',
        currentStatus: 'Current Status',
        driverAssignmentControl: 'Driver Assignment & Control',
        assignedDriver: 'Assigned Driver',
        vehicleNumber: 'Vehicle Number',
        driverContact: 'Driver Contact',
        call: 'Call',
        message: 'Message',
        markAsDelivered: 'Mark as Delivered',
        saveUpdate: 'Save & Update',
        fleetUserStatus: 'Fleet User Status',
        driver: 'Driver',
        currentTrip: 'Current Trip',
        statusLabel: 'Status',
        status: 'Status',
        nextAssignment: 'Next Assignment',
        previous: 'Previous',
        next: 'Next',
        na: 'N/A',
        status: {
          approved: 'In Transit',
          delivered: 'Delivered',
          pending: 'Pending',
          free: 'Free',
        },
        mapAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      },
      invoice: {
        title: 'Invoices & Payments',
        unknown: 'unknown',
        filterBy: 'Filter By',
        date: 'Date',
        tax:'Tax',
        shippingMethod:'Shipping Method',
        view: 'View',
        selectDateRange: 'Select a date range',
        apply: 'Apply',
        paymentMethod: 'Payment Method',
        noPaymentMethods: 'No payment methods available',
        multiplePaymentMethods: '*You can choose multiple Payment Methods',
        applyNow: 'Apply Now',
        status: 'Status',
        selectOrderStatus: 'Select Order Status',
        noStatuses: 'No statuses available',
        multipleOrderStatuses: '*You can choose multiple Order Status',
        location: 'Location',
        selectLocation: 'Select Location',
        multipleLocations: '*You can choose multiple Locations',
        resetFilter: 'Reset Filter',
        createNewInvoice: 'Create New Invoice',
        invoiceNumber: 'Invoice Number',
        invoiceDate: 'Invoice Date',
        dueDate: 'Due Date',
        poNumber: 'PO Number',
        referenceNotes: 'Reference Notes',
        size: 'Size',
        deliveryDate: 'Delivery Date',
        address: 'Address ( Optional )',
        invoiceInformation: 'Invoice Information',
        profileInformation: 'Profile Information',
        city: 'City',
        country: 'Country',
        pinCode: 'Pin Code',
        companyClientInformation: 'Company & Client Information',
        billFrom: 'Bill From',
        billTo: 'Bill To',
        clientAddress: 'Client Address',
        shipmentContainerInformation: 'Shipment/Container Information',
        shipmentId: 'Shipment ID',
        selectShipment: 'Select a Shipment',
        loadingShipments: 'Loading shipments...',
        shipmentIdFormat: 'Shipment {id}',
        containerId: 'Container ID',
        originLocation: 'Origin Location',
        destinationLocation: 'Destination Location',
        description: 'Description',
        removeShipment: 'Remove Shipment',
        addAnotherShipment: 'Add Another Shipment',
        lineItems: 'Line Items (Charge Details)',
        quantity: 'Quantity',
        rate: 'Rate (Price per unit)',
        total: 'Total',
        paymentInformation: 'Payment Information',
        paymentMethods: {
          bankTransfer: 'Bank Transfer',
          creditCard: 'Credit Card',
          paypal: 'PayPal',
        },
        bankDetails: 'Bank Details',
        additionalNotesForClient: 'Additional Notes for Client',
        submitting: 'Submitting...',
        sendInvoice: 'Send Invoice',
        invoiceCreated: 'Invoice Created',
        successfully: 'Successfully',
        successMessage: 'Invoice has been successfully created and saved.',
        checkmarkAlt: 'Checkmark',
        ok: 'OK',
        loadingInvoices: 'Loading invoices...',
        noInvoicesFound: 'No invoices found for the selected filters.',
        invoiceNo: 'Invoice No',
        containerNo: 'Container No.',
        poNo: 'PO No.',
        amount: 'Amount',
        status: 'Status',
        dateIssued: 'Date Issued',
        dueDate: 'Due Date',
        actions: 'Actions',
        na: 'N/A',
        statuses: {
          inTransit: 'In Transit',
          delivered: 'Delivered',
          delayed: 'Delayed',
          pending: 'Pending',
          unknown: 'Unknown',
        },
        showingInvoices: 'Showing {count} of {count} invoices',
        invoicePreview: 'Invoice Preview',
        companyLogo: 'Company Logo\ncustom\nbranding',
        containerMovementInvoice: 'Container Movement Invoice',
        to: 'To',
        totalAmount: 'Total Amount',
        downloadInvoice: 'Download Invoice',
        close: 'Close',
        companyName: 'Your Company Name',
        companyAddress: 'Your Company Address',
        page: 'Page',
        of: 'of',
        thankYou: 'Thank you for your business!',
      },
      ordersContainers: {
        title: 'Reports & Data Management',
        reportsTitle: 'Reports',
        dispatchReports: 'Dispatch Reports',
        containerMovementHistory: 'Container Movement History',
        driverReports: 'Driver Reports',
        generateReport: 'Generate Report',
        trackContainer: 'Track Container',
        saveAndTrack: 'Save & Track',
        date: 'Date',
        totalDispatches: 'Total Dispatches',
        completed: 'Completed',
        delayed: 'Delayed',
        cancelled: 'Cancelled',
        totalInvoiceAmount: 'Total Invoice Amount',
        totalCompletedInvoices: 'Total Completed Invoices Amount: ${amount}',
        driverName: 'Driver Name',
        hoursWorked: 'Hours Worked',
        hours: 'hours',
        loadsCompleted: 'Loads Completed',
        containerId: 'Container ID',
        lastKnownLocation: 'Last Known Location',
        lastUpdate: 'Last Update',
        eta: 'ETA',
        action: 'Action',
        view: 'View',
        containerNumberPlaceholder: 'e.g., TRTR1234567',
        shippingLine: 'Shipping Line',
        selectShippingLine: 'Select Shipping Line',
        emailAddress: 'Email Address',
        emailPlaceholder: 'user@example.com',
        referenceNumber: 'Reference Number',
        referenceNumberPlaceholder: 'y3756fhsfdh',
        containerTrackingDetails: 'Container Tracking Details',
        currentLocation: 'Current Location',
        destination: 'Destination',
        origin: 'Origin',
        estimatedDelivery: 'Estimated Delivery',
        noData: 'No data available',
        truckInspectionReports: 'Truck Inspection Reports',
        driverId: 'Driver ID',
        vehicleNumber: 'Vehicle Number',
        inspectionDate: 'Inspection Date',
        status: 'Status',
        notes: 'Notes',
        truckInspectionNotes: 'All systems operational',
        truckInspectionSent: 'Truck inspection reports sent to dispatcher:',
        paymentMethods: {
          bank_transfer: 'Bank Transfer',
          credit_card: 'Credit Card',
          cash: 'Cash',
          upi: 'UPI',
        },
        status: {
          pass: 'Pass',
          fail: 'Fail',
          in_transit: 'In-Transit',
          delivered: 'Delivered',
          delayed: 'Delayed',
          pending: 'Pending',
          completed: 'Completed',
          in_progress: 'In-Progress',
          active: 'Active',
          optimized: 'Optimized',
        },
        showing: 'Showing {{start}}-{{end}} of {{total}}',
        mapAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        apiResponse: 'API Response:',
        trackingDataLog: 'Tracking Data in Modal:',
        noTrackingData: 'No tracking data available',
      },
      pod: {
        podStatus: 'POD Status',
        pod: 'Proof of Delivery (POD)',
        detailedContainerView: 'Proof of Delivery Detail View',
        save: 'Save',
        deliveryOverview: 'Delivery Overview Panel',
        containerImages: 'Container Images',
        cargoImages: 'Cargo Images',
        deliverySiteImages: 'Delivery Site Images',
        podDocuments: 'POD Documents',
        paymentStatus: 'Payment Status',
        noImages: 'No images available',
        noDocuments: 'No documents available',
        resendPODRequest: 'Resend POD Request',
        downloadReport: 'Download Report',
        requestReason: 'A Reason for Request',
        selectReason: 'Select Reason',
        selectReasonPlaceholder: 'Select type',
        customReason: 'Custom Reason',
        customReasonPlaceholder: 'Write why',
        submitCustomReason: 'Submit custom reason',
        submitRequest: 'Submit',
        cancelRequest: 'Cancel',
        podDownloaded: 'POD Downloaded',
        successfully: 'Successfully',
        downloadSuccessMessage: 'The Proof of Delivery report and images have been successfully downloaded.',
        reasons: {
          incomplete_docs: 'Incomplete Docs',
          blurry_image: 'Blurry Image',
          other: 'Other',
        },
      },

      loads: {
        title: 'LTL / FTL Loads',
        all: 'All',
        ltl: 'LTL',
        ftl: 'FTL',
        type: 'Type',
        origin: 'Origin',
        destination: 'Destination',
        dateTime: 'Date & Time',
        price: 'Price',
        status: 'Status',
        loading: 'Loading...',
        noLoadsFound: 'No loads found.',
        previous: 'Previous',
        next: 'Next',
        page: 'Page {{current}} of {{total}}'
      },
      fleet: {
        noTrip: 'No Trip',
        inTransit: 'In Transit',
        delivered: 'Delivered',
        pending: 'Pending',
        free: 'Free',
        noAssignment: 'No Assignment',
      },
      reports: {
        dailyDispatch: 'Daily Shipment Report', // Updated: "Dispatch" to "Shipment"
        monthlyContainer: 'Monthly Delivery Report',
        routeOptimization: 'Route Optimization',
        paymentSummary: 'Payment Summary',
      },
      orders: {
        appointmentPin: 'Appointment PIN'
        , appointmentPinPlaceholder: 'Enter your appointment PIN',

        "update": "Update",
        "updating": "Updating...",

  distance: 'Distance (Miles)',
  distancePlaceholder: 'Enter distance in Miles',
        "noSealNumber": "Not Assigned",

        "pickFrom": "Pick From (Port Name)",
        "pickFromPlaceholder": "Enter port name",
        "containerNumber": "Container #",
        "containerNumberPlaceholder": "Enter container number",
        "sealNumber": "Seal #",
        "sealNumberPlaceholder": "Enter seal number",
        "size": "Size #",
        "sizePlaceholder": "Enter size",
        "pinNumberOptional": "Pin # (Optional)",
        "pinNumberPlaceholder": "Enter pin number if needed",
        "importLocation": "Import Location",
        "importLocationPlaceholder": "Enter import location",
        "poNumber": "PO Number",
        "poNumberPlaceholder": "Enter PO number",
        "deliveryDate": "Delivery Date",
        "deliveryAppointment": "Delivery Appointment",
        "deliveryAppointmentPlaceholder": "Enter appointment details",
        "deliveryTime": "Delivery Time",
        "commodity": "Commodity",
        "commodityPlaceholder": "Enter commodity",
        "returnEmpty": "Return Empty",
        "returnEmptyPlaceholder": "Dispatch will tell driver where to return",
        "appointmentReturnEmpty": "Appointment to Return Empty",
        "appointmentReturnEmptyPlaceholder": "Sent after unloading",
        "ticketOrPinReturnEmpty": "Ticket or Pin to Return Empty",
        "ticketOrPinReturnEmptyPlaceholder": "Enter ticket or pin",




        deliveryDate: 'Delivery Date',
        deliveryAddress: 'Delivery Address',
        deliveryAddressPlaceholder: 'e.g., 456 Destination St, Houston, TX',
        viewInFull: 'View Full Map',
        // **Add Pick-up fields**
        pickupDate: 'Pick-up Date',
        pickupAddress: 'Pick-up Address',
        pickupAddressPlaceholder: 'e.g., 789 Pick-up St, Phoenix, AZ',
        "pickupTime": "Pickup Time",
        pickFrom: 'Pick From (Port Name)',
        pickFromPlaceholder: 'Enter port name where import is picked up',
        containerNumber: 'Container Number',
        containerNumberPlaceholder: 'e.g., CONT1234567',
        sealNumber: 'Seal Number',
        sealNumberPlaceholder: 'e.g., SEAL987654',
        pinNumber: 'Pin Number',
        pinNumberPlaceholder: 'e.g., PIN1234 (Optional)',
        importLocation: 'Import Location',
        importLocationPlaceholder: 'e.g., Port of Houston',
        poNumber: 'PO Number',
        poNumberPlaceholder: 'e.g., PO1234567890',
        deliveryAppointment: 'Delivery Appointment',
        deliveryAppointmentPlaceholder: 'Enter delivery appointment (optional)',
        deliveryTime: 'Delivery Time',
        deliveryTimePlaceholder: 'e.g., 15:00',
        commodity: 'Commodity',
        commodityPlaceholder: 'e.g., Electronics, Machinery, etc.',


        title: 'Orders & Containers Management',

        dispatchMode: 'Dispatch Mode',

        selectShippingMethod: 'Select Shipping Method',
        selectDispatchMode: 'Select Dispatch Mode',
        selectContainerPlaceholder: 'Select a Container (optional for exports)',
        selectContainers: 'Select Container',
        Dispatch: 'Dispatch',
        selectDispatchModePlaceholder: "Select Dispatch Mode",
        pickUpLoad: "Pick-up Load",
        selectOnMap: "Select on Map",
        saveLocation: "Save Location",
        coordinates: "Coordinates",
        selectOriginLocation: "Select Origin Location",
        selectDestinationLocation: "Select Destination Location",
        selectIntermediateLocation: "Select Intermediate Stop Location",
        delivery: "Delivery",
        stopTypePlaceholder: "Select Stop Type",
        selectStopType: "Select Stop Type",
        selectContainer: 'Select Container',
        createImportDispatch: 'Create Import Dispatch',
        exportContainerNote: 'Note - Container number will be assigned at the port for export shipments.',
        pinNumber: 'Pin Number',
        importLocation: 'Import Location',
        poNumber: 'PO Number',
        createExportDispatch: 'Create Export Dispatch',
        removeContainer: 'Remove Container',
        filterBy: 'Filter By',
        date: 'Date',
        location: 'Location',
        statusLabel: 'Status',
        FTL: 'FTL - Full Truckload',
        selectPortDispatch: 'Select Port Dispatch',
        shippingLine: 'Shipping Line',
        containers: 'Containers',
        addContainer: 'Add Container',
        status: {
          pending: 'Pending',
          inTransit: 'In Transit',
          delivered: 'Delivered',
        },
        multipleDates: 'You can choose multiple dates',
        apply: 'Apply',
        multipleLocations: '*You can choose multiple Locations',
        applyNow: 'Apply Now',
        selectOrderStatus: 'Select Order Status',
        multipleOrderStatus: '*You can choose multiple Order Status',
        resetFilter: 'Reset Filter',
        createNewDispatch: 'Create New Dispatch Order', // Updated: "Dispatch" to "Shipment"
        createNewContainer: '+ Create New Dispatch Order',
        import: 'Import',
        export: 'Export',
        dispatch: 'Create Shipment', // Updated: "Dispatch" to "Create Shipment"
        orderId: 'Order ID',
        orderIdPlaceholder: 'e.g., ORD123456',
        origin: 'Origin',
        originPlaceholder: 'e.g., Los Angeles, CA',
        destination: 'Destination',
        destinationPlaceholder: 'e.g., Houston, TX',
        goodsDescription: 'Goods Description',
        goodsDescriptionPlaceholder: 'e.g., Electronics shipment',
        noOfPallets: 'Number of Pallets',
        noOfPalletsPlaceholder: 'e.g., 10',
        weightInTons: 'Weight (in Tons)',
        weightInTonsPlaceholder: 'e.g., 5',
        pricelabel: 'Pricing Details',
        goodsType: 'Goods Type',
        LTL: 'LTL – Less Than Truckload',
        FTL: 'Full Truckload',

        selectGoodsType: 'Select Goods Type',
        goodsTypeOptions: {
          electronics: 'Electronics',
          textile: 'Textile',
          food: 'Food',
        },
        pickUpDateTime: 'Pick Up Date/Time',
        dropOffDateTime: 'Drop Off Date/Time',
        pickUpHours: 'Pick Up Hours',
        pickUpHoursPlaceholder: 'e.g., 09:00',
        dropOffHours: 'Drop Off Hours',
        dropOffHoursPlaceholder: 'e.g., 17:00',
        containerDetails: 'Container Details',
        containerType: 'Container Type',
        containerTypePlaceholder: 'e.g., 40ft High Cube',
        containerComments: 'Container Comments',
        containerCommentsPlaceholder: 'e.g., Fragile items, handle with care',
        containerNumber: 'Container Number',
        containerNumberPlaceholder: 'e.g., CONT1234567',
        length: 'Length',
        lengthPlaceholder: 'e.g., 12m',
        weight: 'Weight',
        weightPlaceholder: 'e.g., 1000kg',
        commodity: 'Commodity',
        commodityPlaceholder: 'e.g., Laptops',
        routeDeliveryInfo: 'Route & Delivery Info',
        intermediateStop: 'Intermediate Stop {{index}}',
        intermediateStopPlaceholder: 'e.g., Phoenix, AZ',
        addIntermediateStop: '+ Add Intermediate Stop',
        terminal: 'Terminal',
        terminalPlaceholder: 'e.g., Terminal A',
        routeNotes: 'Route Notes',
        routeNotesPlaceholder: 'e.g., Route via I-10',
        driverAssignment: 'Driver Assignment',
        assignedDriver: 'Assigned Driver',
        selectDriver: 'Select Driver',
        searchDriverPlaceholder: 'Search driver name or ID',
        loadingDrivers: 'Loading drivers...',
        noDriverFound: 'No driver found',
        vehicleNumber: 'Vehicle Number',
        vehicleNumberPlaceholder: 'e.g., TX1234XYZ',
        driverContact: 'Driver Contact',
        driverContactPlaceholder: 'e.g., +15556667777',
        addedOn: 'Added On',
        estimatedDeliveryDate: 'Estimated Delivery Date',
        portDetails: 'Port Details',
        portName: 'Port Name',
        portNamePlaceholder: 'e.g., Port of LA',
        ticketNumber: 'Ticket/PIN Number',
        ticketNumberPlaceholder: 'e.g., TICKET987654',
        bookingNumber: 'PO Number',
        bookingNumberPlaceholder: 'e.g., PO1234567890',

        price: 'Price',
        pricePlaceholder: 'e.g., 1200',
        selectStatus: 'Select Status',
        assign: 'Assign',
        assigned: 'Assigned',
        successfully: 'Successfully',
        successMessage: 'Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.',
        ok: 'OK',
        containerId: 'Container ID',
        containerIdPlaceholder: 'Enter Container ID',

               containerNumber: 'Container Number',
        containerNumberPlaceholder: 'Enter Container Number',
        purchaseOrderNo: 'Purchase Order No.',
        originDestination: 'Origin → Destination',
        importExportType: {
          import: 'Import',
          export: 'Export',
          dispatch: 'Shipment', // Updated: "Dispatch" to "Shipment"
        },
        eta: 'ETA',
        etaPlaceholder: 'Enter ETA (e.g., 3 days)',
        actions: 'Actions',
        view: 'View',
        showing: 'Showing {{start}}-{{end}} of {{total}}',
        previous: 'Previous',
        next: 'Next',
        noShipmentsFound: 'No shipments found',
        detailedContainerView: 'Detailed Container View',
        shipmentOverview: 'Shipment Overview',
        stopsList: 'Stops List',
        stopsListPlaceholder: 'Enter stops as: City - MM/DD/YYYY, HH:MM:SS AM/PM (one per line)',
        driverAssignmentControl: 'Driver Assignment & Control',
        store: 'Store',
        storePlaceholder: 'Enter Store',
        update: 'Update',
        loading: 'Loading...',
        na: 'N/A',
        createLTLDispatch: 'Create LTL Shipment', // Updated: "Dispatch" to "Shipment"
        createFTLDispatch: 'Create FTL Shipment', // Updated: "Dispatch" to "Shipment"
        returnFull: 'Return Full (Optional)',
        returnFullPlaceholder: 'e.g., Full Return Details',
        trailerNumber: 'Trailer Number',
        trailerNumberPlaceholder: 'e.g., TRLR123456',
        bookingNumbers: 'Booking Number',
        bookingNumberPlaceholders: 'e.g., BO1234567890',
        "updateSealNumberButton": "Update Seal Number",
        "addSealNumberButton": "Add Seal Number",
        "sealNumberPlaceholder": "e.g., SEAL12345",
        intermediateStops: 'Intermediate Stops',
        stopDestinationPlaceholder: 'e.g., Phoenix, AZ (Stop {{index}})',
        stopTimePlaceholder: 'e.g., 14:00 (Stop {{index}})',
        addStop: 'Add Stop',
        removeStop: 'Remove Stop',
        shippingMethod: 'Shipping Method',
        shippingMethodPlaceholder: 'e.g., Standard',
        pickEmpty: 'Pick Empty (Optional)',
        pickEmptyPlaceholder: 'e.g., Empty Container Pickup',
        sl: 'Shipping Line',
        selectShippingLine: 'Select Shipping Line',
        size: 'Size',
        selectSize: 'Select Size (e.g., 20ft, 40ft)',
        flatBeds: 'Flat Beds',
        flatBedsPlaceholder: 'e.g., 2 Flat Beds',
        loadDate: 'Load Date',
        loadTime: 'Load Time',
        loadAddress: 'Load Address',
        loadAddressPlaceholder: 'e.g., 123 Warehouse St, Los Angeles, CA',
        errors: {
          requiredField: 'Please fill in the {{field}} field',
          invalidStopFormat: 'Invalid format for intermediate destinations. Use: City - MM/DD/YYYY, HH:MM:SS AM/PM',
          unexpectedApiResponse: 'Unexpected API response structure: No valid docs array found',
          fetchDriversFailed: 'Failed to load drivers: {{message}}',
          noDriversFound: 'No drivers found with userType: DRIVER',
          createShipmentFailed: 'Failed to create shipment', // Updated: "Shipment" for consistency
          fetchShipmentsFailed: 'Failed to fetch shipments',
          fetchShipmentDetailsFailed: 'Failed to load shipment details',
          error: 'Info',
          fetchImageFailed: 'Failed to fetch {{name}}',
          downloadReportFailed: 'Failed to download report: {{message}}',
        },











      },



      driverManagement: {
        header: "Driver Management",
        maxDriverLimitReached: "You have reached the maximum limit of {{limit}} drivers for your current package."
        ,
        addNewDriverButton: "Add New Driver",
        filters: {
          filterBy: "Filter By",
          date: "Date",
          dateTooltip: "You can choose multiple dates",
          location: "Location",
          locationTitle: "User Location",
          locationTooltip: "*You can choose multiple Locations",
          status: "Status",
          statusTitle: "Select Order Status",
          statusTooltip: "*You can choose multiple Order Status",
          reset: "Reset Filter",
          apply: "Apply",

          applyNow: "Apply Now",
        },
        driverForm: {
          modalTitle: "Add New Driver",
modalTitleEdit: "Edit Driver", // ✅ NEW: Title for Edit Mode
// 

driverNameLabel: "Driver Name",
          driverNamePlaceholder: "Enter full name",
          driverIdLabel: "Driver ID",
          driverIdPlaceholder: "Enter ID",
          mobileNumberLabel: "Mobile Number",
          mobileNumberPlaceholder: "Enter mobile number",
          emailLabel: "Email Address",
          truckNumberLabel: "Truck Number",
          truckNumberPlaceholder: "Enter the truck number",
          emailPlaceholder: "Enter email",
          addressLabel: "Address",
          addressPlaceholder: "Enter address",
          passwordLabel: "Password",
          passwordPlaceholder: "Enter password",
          drivingLicenseLabel: "Driving License",
          nationalIdLabel: "National ID",
          medicalClearanceLabel: "Medical Clearance",
          backgroundCheckLabel: "Background Check",
          noFileChosen: "No file chosen",
          upload: "Upload",
          submit: "Submit",
          submitting: "Submitting..."
        },
        driverTable: {
          headers: {
            name: "NAME",
            driverId: "Driver ID",
            phone: "Phone Number",
            status: "Status",
            truckNumber: "Trucker Number",
            assignedTrips: "Assigned Trips"
          },
          noDrivers: "No drivers available",
          showing: "Showing 1-{{count}} of {{total}}"
        },
        fleetManagement: {
          header: "Fleet Management",
          table: {
            headers: {
              name: "NAME",
              driverId: "Driver ID",
              phone: "Phone Number",
              licenseExpiry: "License Expiry",
              status: "Status",
              assignedTrips: "Assigned Trips",
              lastTripStatus: "Last Trip Status",
              actions: "Actions"
            },
            noVehicles: "No vehicles available",
            viewButton: "View",
            showing: "Showing 1-{{count}} of {{total}}"
          }
        },
        alerts: {
          successTitle: "Success!",
          successMessage: "Driver added successfully",
          errorTitle: "Error",
          errorMessage: "Failed to add driver",
          missingFieldTitle: "Missing Field", // ✅ Added this
          missingFieldMessage: "is required",// ✅ Added this
          deleteConfirmTitle: "Are you sure?",
          deleteConfirmText: "You won't be able to revert this!",
          deleteConfirmButton: "Yes, delete it!",
          deletedTitle: "Deleted!",
          deletedText: "Driver has been removed."
        },
        locations: {
          africa: "Africa",
          uk: "UK",
          america: "America",
          caribbean: "Caribbean",
          usa: "USA",
          eu: "EU",
          canada: "Canada",
          australia: "Australia"
        },
        statuses: {
          delivered: "Delivered",
          inTransit: "In-transit",
          delayed: "Delayed"
        }
      }





,
  "incidentReports": {
    "title": "Incident Reports",
    "table": {
      "driver": "Driver",
      "type": "Incident Type",
      "dateTime": "Date & Time",
      "location": "Location",
      "reportedBy": "Reported By",
      "action": "Action",
      "emptyState": "No incident reports found."
    },
    "actions": {
      "viewDetails": "View Details"
    },
    "pagination": {
      "showing": "Showing Page",
      "of": "of",
      "totalIncidents": "Total Incidents",
      "previous": "Previous",
      "next": "Next"
    },
    "modal": {
      "title": "Incident Details",
      "reportId": "Report ID",
      "driverInfo": "Driver Information",
      "fullName": "Full Name",
      "driverId": "Driver ID",
      "description": "Incident Description",
      "noDescription": "No description provided.",
      "dispatcherNotes": "Dispatcher Notes",
      "evidence": "Attached Evidence",
      "noEvidence": "No photos attached to this report."
    }
  }
,


    },
  },
  es: {
    translation: {

      notification: {
        title: 'Notificaciones y Alertas',
        buttons: {
          push: 'Enviar Notificación',
          submit: 'Enviar',
          ok: 'Aceptar',
          view: 'Ver'
        },
        table: {
          header: {
            templateName: 'Nombre de la Plantilla',
            channel: 'Canal',
            date: 'Fecha',
            type: 'Tipo'
          },
          body: {
            specificUser: 'Usuario Específico',
            allChannels: 'Todos los Canales',
            noData: 'No se encontraron notificaciones.',
            showing: 'Mostrando 1-{{count}} de {{total}}'
          }
        },
        modal: {
          createTitle: 'Enviar Notificación',
          detailsTitle: 'Detalles de la Notificación',
          form: {
            titleLabel: 'Título de la Notificación',
            titlePlaceholder: 'Ingrese el título de la notificación',
            descLabel: 'Descripción de la Notificación',
            descPlaceholder: 'Ingrese la descripción de la notificación',
            typeLabel: 'Tipo de Notificación',
            typeSelect: 'Seleccione el tipo de notificación',
            typeOptions: {
              ETA_UPDATE: 'Actualizaciones ETA para Clientes',
              DELAY: 'Notificar Retrasos',
              DELIVERY_CONFIRMATION: 'Confirmación de Entrega de Contenedor',
              PAYMENT_REMINDER: 'Recordatorios de Pago Vencido',
              OTHER: 'Otro'
            },
            dateLabel: 'Hasta la Fecha',
            datePlaceholder: '11 de septiembre de 2025',
            driverLabel: 'Nombre del Conductor (si específico)',
            driverPlaceholder: 'Ingrese ID del conductor',
            sendToAll: 'Enviar a Todos los Conductores'
          }
        },
        success: {
          title: 'Notificación Enviada Correctamente',
          highlight: 'Enviado Correctamente',
          message: 'La notificación ha sido enviada correctamente a los destinatarios seleccionados.'
        },
        viewDetails: {
          description: 'Descripción',
          recipient: 'Destinatario',
          recipientAll: 'Todos los Conductores',
          createdAt: 'Creado el'
        },
        errors: {
          fetch: 'Error al cargar las notificaciones. Por favor, intente actualizar la página.'
        }
      }
      ,


      "client": { "title": "Gestión de Clientes", "addButton": "Agregar Cliente", "addTitle": "Agregar Nuevo Cliente", "submit": "Guardar", "table": { "name": "Nombre", "email": "Correo", "phone": "Teléfono", "company": "Empresa" } },


driverManagement: {
        header: "Gestión de Conductores",
        maxDriverLimitReached: "Has alcanzado el límite máximo de {{limit}} conductores para tu paquete actual.",
        addNewDriverButton: "Añadir Nuevo Conductor",
        filters: {
          filterBy: "Filtrar por",
          date: "Fecha",
          dateTooltip: "Puedes elegir varias fechas",
          location: "Ubicación",
          locationTitle: "Ubicación del Usuario",
          locationTooltip: "*Puedes elegir varias ubicaciones",
          status: "Estado",
          statusTitle: "Seleccionar Estado del Pedido",
          statusTooltip: "*Puedes elegir varios estados de pedido",
          reset: "Restablecer Filtro",
          apply: "Aplicar",
          applyNow: "Aplicar Ahora",
        },
        driverForm: {
          modalTitle: "Añadir Nuevo Conductor",
          modalTitleEdit: "Editar Conductor", // ✅ YA ESTABA
          driverNameLabel: "Nombre del Conductor",
          driverNamePlaceholder: "Introduce el nombre completo",
          driverIdLabel: "ID del Conductor",
          driverIdPlaceholder: "Introduce el ID",
          mobileNumberLabel: "Número de Móvil",
          mobileNumberPlaceholder: "Introduce el número de móvil",
          emailLabel: "Dirección de Correo Electrónico",
          emailPlaceholder: "Introduce el correo electrónico",
          addressLabel: "Dirección",
          addressPlaceholder: "Introduce la dirección",
          passwordLabel: "Contraseña",
          passwordPlaceholder: "Introduce la contraseña",
          drivingLicenseLabel: "Licencia de Conducir",
          nationalIdLabel: "ID Nacional",
          truckNumberLabel: "Número de camión",
          truckNumberPlaceholder: "Ingrese el número del camión",
          medicalClearanceLabel: "Certificado Médico",
          backgroundCheckLabel: "Verificación de Antecedentes",
          noFileChosen: "Ningún archivo elegido",
          upload: "Subir",
          submit: "Enviar",
          update: "Actualizar Conductor", // ✅ NUEVO: Botón para editar
          submitting: "Enviando..."
        },
        driverTable: {
          headers: {
            name: "NOMBRE",
            driverId: "ID del Conductor",
            phone: "Número de Teléfono",
            status: "Estado",
            truckNumber: "Número del camionero",
            assignedTrips: "Viajes Asignados",
            actions: "Acciones" // ✅ NUEVO: Columna de acciones
          },
          noDrivers: "No hay conductores disponibles",
          showing: "Mostrando 1-{{count}} de {{total}}"
        },
        fleetManagement: {
          header: "Gestión de Flota",
          table: {
            headers: {
              name: "NOMBRE",
              driverId: "ID del Conductor",
              phone: "Número de Teléfono",
              licenseExpiry: "Vencimiento de Licencia",
              status: "Estado",
              assignedTrips: "Viajes Asignados",
              lastTripStatus: "Estado del Último Viaje",
              actions: "Acciones"
            },
            noVehicles: "No hay vehículos disponibles",
            viewButton: "Ver",
            showing: "Mostrando 1-{{count}} de {{total}}"
          }
        },
        alerts: {
          successTitle: "¡Éxito!",
          successMessage: "Conductor añadido con éxito",
          updateSuccessMessage: "Conductor actualizado con éxito", // ✅ NUEVO
          errorTitle: "Error",
          errorMessage: "Error al añadir conductor",
          missingFieldTitle: "Campo Obligatorio",
          missingFieldMessage: "es obligatorio",
          // ✅ NUEVO: Alertas de confirmación de eliminación
          deleteConfirmTitle: "¿Estás seguro?",
          deleteConfirmText: "¡No podrás revertir esto!",
          deleteConfirmButton: "¡Sí, eliminar!",
          deletedTitle: "¡Eliminado!",
          deletedText: "El conductor ha sido eliminado."
        },
        locations: {
          africa: "África",
          uk: "RU",
          america: "América",
          caribbean: "Caribe",
          usa: "EE. UU.",
          eu: "UE",
          canada: "Canadá",
          australia: "Australia"
        },
        statuses: {
          delivered: "Entregado",
          inTransit: "En tránsito",
          delayed: "Retrasado"
        }
      }
      ,
  "incidentReports": {
    "title": "Reportes de Incidentes",
    "table": {
      "driver": "Conductor",
      "type": "Tipo de Incidente",
      "dateTime": "Fecha y Hora",
      "location": "Ubicación",
      "reportedBy": "Reportado Por",
      "action": "Acción",
      "emptyState": "No se encontraron reportes de incidentes."
    },
    "actions": {
      "viewDetails": "Ver Detalles"
    },
    "pagination": {
      "showing": "Mostrando Página",
      "of": "de",
      "totalIncidents": "Total de Incidentes",
      "previous": "Anterior",
      "next": "Siguiente"
    },
    "modal": {
      "title": "Detalles del Incidente",
      "reportId": "ID del Reporte",
      "driverInfo": "Información del Conductor",
      "fullName": "Nombre Completo",
      "driverId": "ID del Conductor",
      "description": "Descripción del Incidente",
      "noDescription": "No se proporcionó descripción.",
      "dispatcherNotes": "Notas del Despachador",
      "evidence": "Evidencia Adjunta",
      "noEvidence": "No hay fotos adjuntas a este reporte."
    }
  }
,

      companyProfile: {
        title: "Perfil de la Compañía",
        loading: "Cargando perfil de la compañía...",
        error: "No se pudo cargar tu perfil. Por favor, intenta refrescar la página.",
        tabs: {
          companyDetails: "Detalles de la Compañía",
          contactAddress: "Contacto y Dirección",
          legalDocs: "Documentos Legales y de Registro",
          subscription: "Resumen de Suscripción"
        },
        subscription
          : {
          cancelPlan: "Cancel Subscription"
        }
      },
      companyDetails: {
        companyName: "Nombre de la Compañía",
        website: "Sitio Web (si aplica)",
        websitePlaceholder: "Enlace del Sitio Web",
        companyId: "ID de la Compañía (Auto-generado)",
        industryType: "Tipo de Industria",
        industryTypePlaceholder: "Logística",
        establishedYear: "Año de Establecimiento",
        description: "Descripción / Acerca de",
        descriptionPlaceholder: "Breve resumen de la compañía (máx. 500 caracteres)"
      },
      contactAddress: {
        officialEmail: "Correo Electrónico Oficial",
        supportContact: "Número de Contacto de Soporte",
        officeAddress: "Dirección de la Oficina",
        country: "País",
        city: "Ciudad",
        zipCode: "Código Postal",
        timeZone: "Zona Horaria"
      },
      legalDocs: {
        regNo: "Número de Registro de la Compañía",
        regNoPlaceholder: "Número de Registro de la Compañía",
        gstVat: "Número de GST / IVA",
        gstVatPlaceholder: "Número de GST / IVA",
        uploadLicense: "Subir Licencia de la Compañía*",
        uploadTaxDoc: "Documento de Registro de Impuestos*",
        uploadInsurance: "Prueba de Seguro de Negocios*",
        changeFile: "Cambiar PDF/Imagen",
        uploadFile: "Subir PDF/Imagen"
      },
      subscription: {
        title: "Resumen de Suscripción",
        currentPlan: "Plan Actual:",
        status: "Estado:",
        nextBilling: "Próxima Facturación:",
        paymentMethod: "Método de Pago:",
        pricePerYear: "/Año",
        upgradePlan: "Actualizar Plan",
        cancelPlan: "Cancelar suscripción",


        cancelConfirmationTitle: "¿Estás seguro?",
        cancelConfirmationText: "¿Realmente quieres cancelar tu {{plan}}? Membresía",
        yesCancel: "Sí, cancelar",
        noKeep: "No, mantener",
        cancelled: "Cancelado",
        cancelSuccess: "Tu {{plan}} ha sido cancelado.",
        error: "Error",
        cancelError: "Ocurrió un error al cancelar.",
        stillActive: "Tu suscripción sigue activa 🙂"




      },
      status: {
        Active: "Activo",
        Inactive: "Inactivo",
        Pending: "Pendiente"
      },
      common: {
        saveChanges: "Guardar Cambios",
        notAvailable: "No disponible",
        loading: "Cargando...",
        unknown: "Desconocido"
      },









      alt: {
        companyLogo: 'Logotipo de la Empresa',
        planBadge: 'Insignia del Plan',
        notificationsIcon: 'Ícono de Notificaciones',
        settings: 'Ícono de Configuraciones',
        event: 'Ícono de Evento',
        profile: 'Ícono de Perfil',
        application: 'Ícono de Aplicación',
        profilePicture: 'Foto de Perfil',
        manageAccount: 'Ícono de Gestionar Cuenta',
        manageTeam: 'Ícono de Gestionar Equipo',
        changePassword: 'Ícono de Cambiar Contraseña',
        appPreview1: 'Vista Previa de la Aplicación 1',
        appPreview2: 'Vista Previa de la Aplicación 2',
        googlePlay: 'Google Play Store',
        appStore: 'App Store',
        driverAvatar: 'Avatar del Conductor',
        checkmark: 'Marca de Verificación',
        closeLTLModal: 'Cerrar Modal LTL',
        closeFTLModal: 'Cerrar Modal FTL',
        createLTLDispatch: 'Botón Crear Envío LTL', // Updated: "Despacho" to "Envío"
        createFTLDispatch: 'Botón Crear Envío FTL', // Updated: "Despacho" to "Envío"
        addStop: 'Botón Añadir Parada',
        removeStop: 'Botón Eliminar Parada',
        viewShipment: 'Ver Envío {{id}}', // Updated: "Shipment" for consistency
        closePODModal: 'Cerrar Modal de POD',
        closeRequestModal: 'Cerrar Modal de Solicitud',
        containerImage: 'Imagen del Contenedor {{index}}',
        cargoImage: 'Imagen de la Carga {{index}}',
        deliverySiteImage: 'Imagen del Sitio de Entrega {{index}}',
        podDocument: 'Documento de POD {{index}}',
        selectAll: 'Select all rows',
        selectRow: 'Select row {{index}}',
        viewContainer: 'View container {{id}}',
        closeTrackFormModal: 'Close track container form modal',
        closeTrackingModal: 'Close container tracking details modal',
        selectAll: 'Seleccionar todas las filas',
        selectRow: 'Seleccionar fila {{index}}',
        viewContainer: 'Ver contenedor {{id}}',
        closeTrackFormModal: 'Cerrar modal de formulario de rastreo de contenedor',
        closeTrackingModal: 'Cerrar modal de detalles de rastreo de contenedor',
      },
      search: {
        placeholder: 'Buscar...',
      },
      notifications: {
        title: 'Notificaciones',
        settings: 'Configuraciones Actualizadas',
        settingsUpdate: 'Tus configuraciones han sido actualizadas con éxito.',
        eventUpdate: 'Actualización de Evento',
        eventUpdateDesc: 'Nuevo evento programado para la próxima semana.',
        profile: 'Perfil Actualizado',
        profileUpdate: 'La información de tu perfil ha sido actualizada.',
        applicationError: 'Error de Aplicación',
        applicationErrorDesc: 'Hubo un error con tu última aplicación.',
        seeAll: 'Ver Todas las Notificaciones',
      },
      language: {
        select: 'Seleccionar Idioma',
      },
      profile: {
        dispatcherName: 'Nombre del Gestor de Envíos', // Updated: "Despachador" to "Gestor de Envíos"
        role: 'Rol',
        manageAccount: 'Gestionar Cuenta',
        manageTeam: 'Gestionar Equipo',
        changePassword: 'Cambiar Contraseña',
      },
      profileManagement: {
        title: 'Gestión de Perfil',
        fullName: 'Nombre Completo',
        email: 'Correo Electrónico',
        phone: 'Teléfono',
        position: 'Posición',
        status: 'Estado',
        save: 'Guardar Cambios',
        saving: 'Guardando...',
        cancel: 'Cancelar',
      },
      teamManagement: {
        title: 'Gestión de Equipo',
        description: 'Añade y gestiona a los miembros de tu equipo aquí.',
        memberRole: 'Rol del Miembro',
        selectRole: 'Seleccionar Rol',
        name: 'Nombre',
        namePlaceholder: 'Ingresar nombre completo',
        email: 'Correo Electrónico',
        emailPlaceholder: 'Ingresar dirección de correo electrónico',
        addMember: 'Añadir Miembro',
        adding: 'Añadiendo...',
        noMembers: 'No se encontraron miembros del equipo.',
        viewDashboard: 'Ver Tablero',
        roles: {
          admin: 'Administrador',
          dispatcher: 'Gestor de Envíos', // Updated: "Despachador" to "Gestor de Envíos"
          driver: 'Conductor',
        },
      },
      resetPassword: {
        title: 'Restablecer Contraseña',
        description: 'Ingresa tu nueva contraseña a continuación para restablecerla.',
        password: 'Nueva Contraseña',
        confirmPassword: 'Confirmar Nueva Contraseña',
        terms: 'Acepto los términos y condiciones',
        save: 'Guardar Cambios',
        saving: 'Guardando...',
      },
      success: {
        title: 'Éxito',
        profileUpdated: '¡Perfil actualizado con éxito!',
        passwordChanged: '¡Contraseña cambiada con éxito!',
        confirm: 'Aceptar',
      },
      errors: {
        requiredFields: 'Por favor completa todos los campos obligatorios.',
        updateProfileFailed: 'No se pudo actualizar el perfil. Por favor intenta de nuevo.',
        passwordRequired: 'Ambos campos de contraseña son obligatorios.',
        passwordMismatch: 'Las contraseñas no coinciden.',
        termsRequired: 'Debes aceptar los términos y condiciones.',
        resetPasswordFailed: 'No se pudo restablecer la contraseña. Por favor intenta de nuevo.',
        fetchTeamFailed: 'No se pudieron obtener los miembros del equipo.',
        refreshTeamFailed: 'No se pudieron actualizar los miembros del equipo.',
        addTeamFailed: 'No se pudo añadir al miembro del equipo.',
        fetchDashboardFailed: 'No se pudieron obtener los datos del tablero.',
        fetchUsersFailed: 'No se pudieron obtener los datos de los usuarios.',
        fetchShipmentsFailed: 'No se pudieron obtener los envíos.',
        fetchShipmentDetailsFailed: 'No se pudieron obtener los detalles del envío.',
        error: 'Info',
        selectDispatchType: 'Por favor, seleccione un tipo de despacho',
        selectContainer: 'Seleccionar Contenedores',
        fetchImageFailed: 'No se pudo obtener {{name}}',
        downloadReportFailed: 'No se pudo descargar el informe: {{message}}',
        fetchDispatchReportsFailed: 'Failed to load dispatch reports or invoices.',
        fetchContainerDataFailed: 'Failed to load container data.',
        fetchDriverReportsFailed: 'Failed to load driver reports.',
        fetchShippingLinesFailed: 'Failed to load shipping lines.',
        fetchTruckInspectionsFailed: 'Failed to load truck inspection reports.',
        invalidContainerNumber: 'Container number must be 4 letters followed by 7 numbers (e.g., TRTR1234567).',
        selectShippingLine: 'Please select a shipping line.',
        enterEmailAddress: 'Please enter an email address.',
        enterReferenceNumber: 'Please enter a reference number.',
        fetchTrackingDataFailed: 'Failed to load tracking data: {{message}}',
        invalidCoordinates: 'Unable to display map: Invalid or missing coordinates. Please check the console for details.',

      },
sidebar: {
  dashboard: '🏠 Panel de Control',
  orders: '📝 Pedidos y Contenedores',
  exportContainer:'🚢 Contenedor de Exportación',
  loads: '🚛 Cargas LTL/FTL',
  dispatch: '🚚 Gestión de Envíos',
  pod: '📄 Prueba de Entrega (POD)',
  invoices: '💳 Facturas y Pagos',
  reports: '📊 Informes',
  incidentReport: '⚠️ Informe de Incidente',
  drivers: '👥 Conductores y Flota',
  clientManagement: '🤝 Gestión de Clientes',
  companyProfile: '🏢 Perfil de la Empresa',
  notifications: '🔔 Notificaciones y Alertas',
  messages: '📩 Mensajes',
  dispatcherLinks: '🔗 Enlaces de Despacho',
  logout: '🚪 Cerrar Sesión',
}
,





  "linkData": {
    "title": "Lista de Enlaces",
    "table": {
      "header": {
        "name": "Nombre del Enlace",
        "url": "Dirección URL"
      },
      "body": {
        "noData": "No se encontraron datos de enlaces.",
        "showing": "Mostrando {{count}} de {{total}} elementos"
      }
    },
    "pagination": {
      "previous": "Anterior",
      "next": "Siguiente",
      "pageOf": "Página {{current}} de {{total}}"
    },
    "messages": {
      "errorFetch": "No se pudieron cargar los datos de los enlaces."
    }
  }
,



      dashboard: {
        title: 'Panel de Control',
        inTransitContainers: 'Contenedores en Tránsito',
        totalContainers: 'Total de Contenedores',
        todaysDispatches: 'Envíos de Hoy',
        liveRouteMonitoring: 'Monitoreo de Rutas en Vivo',
        pendingDeliveries: 'Entregas Pendientes',
        trackNow: 'Rastrear Ahora',
        statusUpdates: 'Actualizaciones de Estado',
        stopsList: 'Lista de Paradas',
        dispatchManagement: 'Gestión de Envíos',
        viewAll: 'Ver Todo',
        routeNotes: 'Notas de Ruta',
        availableDrivers: 'Conductores Disponibles',
        automaticAssignment: 'Asignación Automática',
        selectDriverPlaceholder: 'Seleccionar Contenedor',
        dispatchAssignment: 'Asignación de Envíos',
        autoAssignDescription: 'Asignar automáticamente a los conductores y notificar a ambas partes',

        viewTrips: 'Ver Viajes',
        dispatch: 'Crear Envío',
        stayConnected: 'Mantente Conectado',
        totalDispatched: 'Total Enviados',
        totalPending: 'Total Pendientes',
        totalInTransit: 'Total en Tránsito',
        totalDelivered: 'Total Entregados',
        roadsideHelp: 'Asistencia en Carretera',
        realTimeUpdates: 'Actualizaciones en Tiempo Real',
        proofOfDelivery: 'Prueba de Entrega',
        chatWithDispatchers: 'Chatear con Gestores de Envíos',
        documentManagement: 'Gestión de Documentos',
        downloadApp: 'Descargar Aplicación',
        liveContainer: 'Seguimiento de Contenedores en Vivo',
        shipmentId: 'ID de Envío: #{{id}}',
        containerNo: 'N.º de Contenedor: {{number}}',
        driverName: 'Nombre del Conductor: {{name}}',
        view: 'Ver',
        loading: 'Cargando...',
        loadingShipment: 'Cargando detalles del envío...',
        noUsersFound: 'No se encontraron usuarios',
        detailedContainerView: 'Vista Detallada del Contenedor',
        shipmentOverview: 'Resumen del Envío',
        containerId: 'ID del Contenedor',
        purchaseOrderNo: 'N.º de Orden de Compra',
        customerName: 'Nombre del Cliente',
        numberOfPallets: 'Número de Palets',
        goodsType: 'Tipo de Mercancías',
        addedOn: 'Añadido el',
        estimatedDeliveryDate: 'Fecha de Entrega Estimada',
        routeStatusTracking: 'Ruta y Seguimiento del Estado',
        route: 'Ruta',
        mapView: 'Vista del Mapa: {{origin}} → {{destination}}',
        trackContainer: 'Rastrear Contenedor',
        currentStatus: 'Estado Actual',
        driverAssignmentControl: 'Asignación y Control de Conductores',
        assignedDriver: 'Conductor Asignado',
        vehicleNumber: 'Número del Vehículo',
        driverContact: 'Contacto del Conductor',
        call: 'Llamar',
        message: 'Mensaje',
        markAsDelivered: 'Marcar como Entregado',
        saveUpdate: 'Guardar y Actualizar',
        fleetUserStatus: 'Estado de los Usuarios de la Flota',
        driver: 'Conductor',
        currentTrip: 'Viaje Actual',
        statusLabel: 'Estado',

        status: 'Estado',
        nextAssignment: 'Próxima Asignación',
        previous: 'Anterior',
        next: 'Siguiente',
        na: 'N/D',
        status: {
          approved: 'En Tránsito',
          delivered: 'Entregado',
          pending: 'Pendiente',
          free: 'Libre',
        },
        mapAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contribuyentes',
      },



      alt: {
        selectAll: 'Seleccionar todas las filas',
        selectRow: 'Seleccionar la fila {{index}}',
        viewDriver: 'Ver conductor {{id}}',
        viewVehicle: 'Ver vehículo {{id}}',
        closeModal: 'Cerrar ventana de agregar conductor',   // más natural que "modal"
        drivingLicensePreview: 'Vista previa de la licencia de conducir',
        nationalIdPreview: 'Vista previa del documento de identidad',
        medicalClearancePreview: 'Vista previa del certificado médico',
        backgroundCheckPreview: 'Vista previa de la verificación de antecedentes'
      },

      loads: {
        title: 'Cargas LTL / FTL',
        all: 'Todo',
        ltl: 'LTL',
        ftl: 'FTL',
        type: 'Tipo',
        origin: 'Origen',
        destination: 'Destino',
        dateTime: 'Fecha y Hora',
        price: 'Precio',
        status: 'Estado',
        loading: 'Cargando...',
        noLoadsFound: 'No se encontraron cargas.',
        previous: 'Anterior',
        next: 'Siguiente',
        page: 'Página {{current}} de {{total}}'
      },
      fleet: {
        noTrip: 'Sin viajes',              // plural más natural
        inTransit: 'En tránsito',          // minúscula después de preposición
        delivered: 'Entregado',
        pending: 'Pendiente',
        free: 'Disponible',                // "Libre" suena raro, mejor "Disponible"
        noAssignment: 'Sin asignación',
      },

      reports: {
        dailyDispatch: 'Informe diario de envíos',          // más natural
        monthlyContainer: 'Informe mensual de contenedores', // más preciso que "entregas"
        routeOptimization: 'Optimización de rutas',
        paymentSummary: 'Resumen de pagos',
      },

      orders: {
        appointmentPin: 'PIN de cita',
        viewInFull: 'Ver mapa completo',
        deliveryDate: 'Fecha de Entrega',
        deliveryAddress: 'Dirección de Entrega',
        deliveryAddressPlaceholder: 'p. ej., 456 Calle Destino, Houston, TX',
        appointmentPinPlaceholder: 'Ingrese su PIN de cita'
        ,
         distance: 'Distancia (km)',
  distancePlaceholder: 'Ingrese la distancia en km',

        pickupDate: 'Fecha de Recogida',
        "noSealNumber": "No asignado",

        "update": "Actualizar",
        "updating": "Actualizando...",
        pickupAddress: 'Dirección de Recogida',
        pickupAddressPlaceholder: 'p. ej., 789 Calle Recogida, Phoenix, AZ',
        "pickupTime": "Hora de recogida",
        "updateSealNumberButton": "Actualizar número de sello",
        "addSealNumberButton": "Agregar número de sello",
        "bookingNumberPlaceholders": "p. ej., BO1234567890",
        "sealNumberPlaceholder": "p. ej., SELLO12345",
        "pickFrom": "Recoger desde (Puerto)",
        "pickFromPlaceholder": "Ingrese el nombre del puerto",
        "containerNumber": "Contenedor #",
        "containerNumberPlaceholder": "Ingrese el número de contenedor",
        "sealNumber": "Sello #",
        "sealNumberPlaceholder": "Ingrese el número de sello",
        "size": "Tamaño #",
        "sizePlaceholder": "Ingrese el tamaño",
        "pinNumberOptional": "PIN # (Opcional)",
        "pinNumberPlaceholder": "Ingrese el PIN si es necesario",
        "importLocation": "Ubicación de Importación",
        "importLocationPlaceholder": "Ingrese la ubicación de importación",
        "poNumber": "Número de Pedido (PO)",
        "poNumberPlaceholder": "Ingrese el número de pedido",
        "deliveryDate": "Fecha de Entrega",
        "deliveryAppointment": "Cita de Entrega",
        "deliveryAppointmentPlaceholder": "Ingrese los detalles de la cita",
        "deliveryTime": "Hora de Entrega",
        "commodity": "Mercancía",
        "commodityPlaceholder": "Ingrese la mercancía",
        "returnEmpty": "Devolver Vacío",
        "returnEmptyPlaceholder": "Despacho indicará dónde devolverlo",
        "appointmentReturnEmpty": "Cita para Devolver Vacío",
        "appointmentReturnEmptyPlaceholder": "Se enviará después de descargar",
        "ticketOrPinReturnEmpty": "Boleto o PIN para Devolver Vacío",
        "ticketOrPinReturnEmptyPlaceholder": "Ingrese el boleto o PIN",
        title: 'Gestión de Órdenes y Contenedores',
        filterBy: 'Filtrar por',

        dispatchMode: 'Modo de Envío',
        selectShippingMethod: 'Seleccionar Método de Envío',
        LTL: 'LTL – Menos de un camión completo',
        Dispatch: 'Envío',
        selectDispatchMode: 'Seleccionar Modo de Envío',
        selectOnMap: "Seleccionar en el mapa",
        saveLocation: "Guardar ubicación",
        coordinates: "Coordenadas",
        selectOriginLocation: "Seleccionar ubicación de origen",
        selectDestinationLocation: "Seleccionar ubicación de destino",
        selectIntermediateLocation: "Seleccionar ubicación de parada intermedia",
        selectDispatchModePlaceholder: "Seleccionar Modo de Envío",
        pickUpLoad: "Carga de Recogida",
        delivery: "Entrega",
        stopTypePlaceholder: "Seleccionar Tipo de Parada",
        selectStopType: "Seleccionar Tipo de Parada",
        removeContainer: 'Eliminar Contenedor',
        selectContainerPlaceholder: 'Seleccione un contenedor (opcional para exportaciones)',
        pinNumber: 'Número PIN',
        importLocation: 'Lugar de Importación',
        poNumber: 'Número de Orden de Compra',
        createImportDispatch: 'Crear Envío de Importación',

        shippingLine: 'Línea Naviera',
        addContainer: 'Agregar Contenedor',
        createExportDispatch: 'Crear Envío de Exportación',
        selectContainers: 'Seleccionar Contenedores',
        exportContainerNote: 'Nota - El número de contenedor se asignará en el puerto para los envíos de exportación.',
        selectContainer: 'Seleccionar Contenedor',

        date: 'Fecha',
        location: 'Ubicación',
        statusLabel: 'Estado',
        selectPortDispatch: 'Seleccionar Envío Portuario',
        containers: 'Contenedores',

        status: {
          pending: 'Pendiente',
          inTransit: 'En Tránsito',
          delivered: 'Entregado',
        },
        multipleDates: 'Puedes elegir múltiples fechas',
        FTL: 'FTL – Camión completo',
        apply: 'Aplicar',
        multipleLocations: '*Puedes elegir múltiples ubicaciones',
        applyNow: 'Aplicar ahora',
        selectOrderStatus: 'Seleccionar Estado de la Orden',
        multipleOrderStatus: '*Puedes elegir múltiples estados de orden',
        resetFilter: 'Restablecer Filtro',
        createNewDispatch: 'Crear Nueva Orden de Envío',
        createNewContainer: '+ Crear Nuevo Pedido de Despacho',
        import: 'Importar',
        export: 'Exportar',
        dispatch: 'Crear Envío',
        orderId: 'ID de Orden',
        orderIdPlaceholder: 'p. ej., ORD123456',
        origin: 'Origen',
        originPlaceholder: 'p. ej., Los Ángeles, CA',
        destination: 'Destino',
        destinationPlaceholder: 'p. ej., Houston, TX',
        goodsDescription: 'Descripción de Mercancías',
        goodsDescriptionPlaceholder: 'p. ej., Envío de electrónicos',
        noOfPallets: 'Número de Palets',
        noOfPalletsPlaceholder: 'p. ej., 10',
        weightInTons: 'Peso (en toneladas)',
        weightInTonsPlaceholder: 'p. ej., 5',
        pricelabel: 'Detalles de Precios',
        goodsType: 'Tipo de Mercancías',
        selectGoodsType: 'Seleccionar Tipo de Mercancías',
        goodsTypeOptions: {
          electronics: 'Electrónicos',
          textile: 'Textiles',
          food: 'Alimentos',
        },
        pickUpDateTime: 'Fecha/Hora de Recogida',
        dropOffDateTime: 'Fecha/Hora de Entrega',
        pickUpHours: 'Horario de Recogida',
        pickUpHoursPlaceholder: 'p. ej., 09:00',
        dropOffHours: 'Horario de Entrega',
        dropOffHoursPlaceholder: 'p. ej., 17:00',
        containerDetails: 'Detalles del Contenedor',
        containerType: 'Tipo de Contenedor',
        containerTypePlaceholder: 'p. ej., Cubo Alto de 40 pies',
        containerComments: 'Comentarios del Contenedor',
        containerCommentsPlaceholder: 'p. ej., Artículos frágiles, manejar con cuidado',
        containerNumber: 'Número de Contenedor',
        containerNumberPlaceholder: 'p. ej., CONT1234567',
        length: 'Longitud',
        lengthPlaceholder: 'p. ej., 12m',
        weight: 'Peso',
        weightPlaceholder: 'p. ej., 1000kg',
        commodity: 'Mercancía',
        commodityPlaceholder: 'p. ej., Portátiles',
        routeDeliveryInfo: 'Ruta e Información de Entrega',
        intermediateStop: 'Parada Intermedia {{index}}',
        intermediateStopPlaceholder: 'p. ej., Phoenix, AZ',
        addIntermediateStop: '+ Añadir Parada Intermedia',
        terminal: 'Terminal',
        terminalPlaceholder: 'p. ej., Terminal A',
        routeNotesPlaceholder: 'p. ej., Ruta vía I-10',
        driverAssignment: 'Asignación de Conductor',
        assignedDriver: 'Conductor Asignado',
        selectDriver: 'Seleccionar Conductor',
        searchDriverPlaceholder: 'Buscar nombre o ID del conductor',
        loadingDrivers: 'Cargando conductores...',
        noDriverFound: 'No se encontró conductor',
        vehicleNumber: 'Número de Vehículo',
        vehicleNumberPlaceholder: 'p. ej., TX1234XYZ',
        driverContact: 'Contacto del Conductor',
        driverContactPlaceholder: 'p. ej., +15556667777',
        addedOn: 'Añadido el',
        estimatedDeliveryDate: 'Fecha de Entrega Estimada',
        portDetails: 'Detalles del Puerto',
        portName: 'Nombre del Puerto',
        portNamePlaceholder: 'p. ej., Puerto de LA',
        ticketNumber: 'Número de Ticket/PIN',
        ticketNumberPlaceholder: 'p. ej., TICKET987654',
        bookingNumber: 'Número de PO',
        bookingNumberPlaceholder: 'p. ej., PO1234567890',


        price: 'Precio',
        pricePlaceholder: 'p. ej., 1200',
        selectStatus: 'Seleccionar Estado',
        assign: 'Asignar',
        assigned: 'Asignado',
        successfully: 'Exitosamente',
        successMessage: 'Operación completada con éxito.',
        ok: 'Aceptar',
        containerId: 'ID del Contenedor',
        containerIdPlaceholder: 'Ingresar ID del Contenedor',
        purchaseOrderNo: 'No. de Orden de Compra',
        originDestination: 'Origen → Destino',
        importExportType: {
          import: 'Importar',
          export: 'Exportar',
          dispatch: 'Envío',
        },
        eta: 'ETA',
        etaPlaceholder: 'Ingresar ETA (p. ej., 3 días)',
        actions: 'Acciones',
        view: 'Ver',
        showing: 'Mostrando {{start}}-{{end}} de {{total}}',
        previous: 'Anterior',
        next: 'Siguiente',
        noShipmentsFound: 'No se encontraron envíos',
        detailedContainerView: 'Vista Detallada del Contenedor',
        shipmentOverview: 'Resumen del Envío',
        stopsList: 'Lista de Paradas',
        stopsListPlaceholder: 'Ingresar paradas como: Ciudad - DD/MM/AAAA, HH:MM:SS (una por línea)',
        driverAssignmentControl: 'Asignación y Control de Conductores',
        store: 'Tienda',
        storePlaceholder: 'Ingresar Tienda',
        update: 'Actualizar',
        loading: 'Cargando...',
        na: 'N/D',
        createLTLDispatch: 'Crear Envío LTL',
        createFTLDispatch: 'Crear Envío FTL',
        returnFull: 'Retorno Completo',
        returnFullPlaceholder: 'p. ej., Detalles de Retorno Completo',
        trailerNumber: 'Número de Remolque',
        trailerNumberPlaceholder: 'p. ej., TRLR123456',
        intermediateStops: 'Paradas Intermedias',
        stopDestinationPlaceholder: 'p. ej., Phoenix, AZ (Parada {{index}})',
        stopTimePlaceholder: 'p. ej., 14:00 (Parada {{index}})',
        addStop: 'Añadir Parada',
        removeStop: 'Eliminar Parada',
        shippingMethod: 'Método de Envío',
        shippingMethodPlaceholder: 'p. ej., Estándar',
        pickEmpty: 'Recogida Vacía',
        pickEmptyPlaceholder: 'p. ej., Recogida de Contenedor Vacío',
        sl: 'Línea Naviera',
        selectShippingLine: 'Seleccionar Línea Naviera',
        size: 'Tamaño',
        selectSize: 'Seleccionar Tamaño (p. ej., 20 pies, 40 pies)',
        flatBeds: 'Camas Planas',
        flatBedsPlaceholder: 'p. ej., 2 Camas Planas',
        loadDate: 'Fecha de Carga',
        loadTime: 'Hora de Carga',
        loadAddress: 'Dirección de Carga',
        loadAddressPlaceholder: 'p. ej., 123 Calle Almacén, Los Ángeles, CA',
        errors: {
          requiredField: 'Por favor completa el campo {{field}}',
          invalidStopFormat: 'Formato inválido para destinos intermedios. Usa: Ciudad - DD/MM/AAAA, HH:MM:SS',
          unexpectedApiResponse: 'Estructura de respuesta inesperada: No se encontró un arreglo de documentos válido',
          fetchDriversFailed: 'No se pudieron cargar los conductores: {{message}}',
          noDriversFound: 'No se encontraron conductores con userType: DRIVER',
          createShipmentFailed: 'No se pudo crear el envío',
          fetchShipmentsFailed: 'No se pudieron obtener los envíos',
          fetchShipmentDetailsFailed: 'No se pudieron cargar los detalles del envío',
          error: 'Error: {{message}}',
          fetchVehiclesFailed: 'No se pudieron obtener los vehículos',
          addDriverFailed: 'No se pudo agregar el conductor'
        },
      },

      ordersContainers: {
        title: 'Informes y Gestión de Datos',
        dispatchReports: 'Informes de Envío',
        reportsTitle: 'Informes',
        containerMovementHistory: 'Historial de Movimiento de Contenedores',
        driverReports: 'Informes de Conductores',
        generateReport: 'Generar Informe',
        trackContainer: 'Rastrear Contenedor',
        saveAndTrack: 'Guardar y Rastrear',
        date: 'Fecha',
        totalDispatches: 'Envíos Totales',
        completed: 'Completado',
        delayed: 'Retrasado',
        cancelled: 'Cancelado',
        totalInvoiceAmount: 'Monto Total de Facturas',
        totalCompletedInvoices: 'Monto Total de Facturas Completadas: ${amount}',
        driverName: 'Nombre del Conductor',
        hoursWorked: 'Horas Trabajadas',
        hours: 'Horas',
        loadsCompleted: 'Cargas Completadas',
        containerId: 'ID del Contenedor',
        lastKnownLocation: 'Última Ubicación Conocida',
        lastUpdate: 'Última Actualización',
        eta: 'ETA',
        action: 'Acción',
        view: 'Ver',
        containerNumberPlaceholder: 'p. ej., TRTR1234567',
        shippingLine: 'Línea Naviera',
        selectShippingLine: 'Seleccionar Línea Naviera',
        emailAddress: 'Correo Electrónico',
        emailPlaceholder: 'usuario@ejemplo.com',
        referenceNumber: 'Número de Referencia',
        referenceNumberPlaceholder: 'y3756fhsfdh',
        containerTrackingDetails: 'Detalles de Rastreo del Contenedor',
        currentLocation: 'Ubicación Actual',
        destination: 'Destino',
        origin: 'Origen',
        estimatedDelivery: 'Entrega Estimada',
        noData: 'No hay datos disponibles',
        truckInspectionReports: 'Informes de Inspección de Camiones',
        driverId: 'ID del Conductor',
        vehicleNumber: 'Número de Vehículo',
        inspectionDate: 'Fecha de Inspección',
        status: 'Estado',
        notes: 'Notas',
        truckInspectionNotes: 'Todos los sistemas operativos',
        truckInspectionSent: 'Informes de inspección enviados al gestor de envíos:',
        paymentMethods: {
          bank_transfer: 'Transferencia Bancaria',
          credit_card: 'Tarjeta de Crédito',
          cash: 'Efectivo',
          upi: 'UPI',
        },
        status: {
          pass: 'Aprobado',
          fail: 'Fallido',
          in_transit: 'En Tránsito',
          delivered: 'Entregado',
          delayed: 'Retrasado',
          pending: 'Pendiente',
          completed: 'Completado',
          in_progress: 'En Progreso',
          active: 'Activo',
          optimized: 'Optimizado',
        },
        showing: 'Mostrando {{start}}-{{end}} de {{total}}',
        mapAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> colaboradores',
        apiResponse: 'Respuesta de la API:',
        trackingDataLog: 'Datos de Rastreo en Modal:',
        noTrackingData: 'No hay datos de rastreo disponibles',
      },

      invoice: {
        title: 'Facturas y Pagos',
        filterBy: 'Filtrar por',
        view: 'Vista',
tax:'declaración de impuestos',
shippingMethod:'método de envío',
        date: 'Fecha',
        selectDateRange: 'Seleccionar rango de fechas',
        apply: 'Aplicar',
        paymentMethod: 'Método de Pago',
        noPaymentMethods: 'No hay métodos de pago disponibles',
        multiplePaymentMethods: '*Puedes elegir múltiples métodos de pago',
        applyNow: 'Aplicar ahora',
        status: 'Estado',
        selectOrderStatus: 'Seleccionar Estado del Pedido',
        noStatuses: 'No hay estados disponibles',
        multipleOrderStatuses: '*Puedes elegir múltiples estados de pedido',
        location: 'Ubicación',
        selectLocation: 'Seleccionar ubicación',
        multipleLocations: '*Puedes elegir múltiples ubicaciones',
        resetFilter: 'Restablecer filtro',
        createNewInvoice: 'Crear Nueva Factura',
        invoiceNumber: 'Número de Factura',
        invoiceDate: 'Fecha de Factura',
        dueDate: 'Fecha de Vencimiento',
        poNumber: 'Número de Orden de Compra',
        referenceNotes: 'Notas de Referencia',
        size: 'Tamaño',
        deliveryDate: 'Fecha de Entrega',
        address: 'Dirección',
        invoiceInformation: 'Información de la Factura',
        profileInformation: 'Información del Perfil',
        city: 'Ciudad',
        country: 'País',
        pinCode: 'Código Postal',
        companyClientInformation: 'Información de la Empresa y el Cliente',
        billFrom: 'Facturado desde',
        billTo: 'Facturado a',
        clientAddress: 'Dirección del Cliente',
        shipmentContainerInformation: 'Información de Envío/Contenedor',
        shipmentId: 'ID de Envío',
        selectShipment: 'Seleccionar envío',
        loadingShipments: 'Cargando envíos...',
        shipmentIdFormat: 'Envío {id}',
        containerId: 'ID del Contenedor',
        originLocation: 'Ubicación de Origen',
        destinationLocation: 'Ubicación de Destino',
        description: 'Descripción',
        removeShipment: 'Eliminar envío',
        addAnotherShipment: 'Agregar otro envío',
        lineItems: 'Elementos de Línea',
        quantity: 'Cantidad',
        rate: 'Tarifa (Precio por unidad)',
        total: 'Total',
        paymentInformation: 'Información de Pago',
        paymentMethods: {
          bankTransfer: 'Transferencia Bancaria',
          creditCard: 'Tarjeta de Crédito',
          paypal: 'PayPal',
        },
        bankDetails: 'Detalles Bancarios',
        additionalNotesForClient: 'Notas Adicionales para el Cliente',
        submitting: 'Enviando...',
        sendInvoice: 'Enviar Factura',
        invoiceCreated: 'Factura Creada',
        successfully: 'Exitosamente',
        successMessage: 'La factura ha sido creada y guardada exitosamente.',
        checkmarkAlt: 'Marca de verificación',
        ok: 'Aceptar',
        loadingInvoices: 'Cargando facturas...',
        noInvoicesFound: 'No se encontraron facturas para los filtros seleccionados.',
        invoiceNo: 'Nº de Factura',
        containerNo: 'Nº de Contenedor',
        poNo: 'Nº de Orden de Compra',
        amount: 'Monto',
        status: 'Estado',
        dateIssued: 'Fecha de Emisión',
        dueDate: 'Fecha de Vencimiento',
        actions: 'Acciones',
        na: 'N/D',
        statuses: {
          inTransit: 'En Tránsito',
          delivered: 'Entregado',
          delayed: 'Retrasado',
          pending: 'Pendiente',
          unknown: 'Desconocido',
        },
        unknown: 'Desconocido',
        showingInvoices: 'Mostrando {count} de {count} facturas',
        invoicePreview: 'Vista Previa de la Factura',
        companyLogo: 'Logotipo de la Empresa\npersonalización\nde marca',
        containerMovementInvoice: 'Factura de Movimiento de Contenedores',
        to: 'Para',
        totalAmount: 'Monto Total',
        downloadInvoice: 'Descargar Factura',
        close: 'Cerrar',
        companyName: 'Nombre de la Empresa',
        companyAddress: 'Dirección de la Empresa',
        page: 'Página',
        of: 'de',
        thankYou: '¡Gracias por su negocio!',
      },

      pod: {
        podStatus: 'Estado de POD',
        pod: 'Prueba de Entrega (POD)',
        detailedContainerView: 'Vista Detallada de POD',
        deliveryOverview: 'Resumen de Entrega',
        save: 'Guardar',

        containerImages: 'Imágenes del Contenedor',
        cargoImages: 'Imágenes de la Carga',
        deliverySiteImages: 'Imágenes del Sitio de Entrega',
        podDocuments: 'Documentos de POD',
        paymentStatus: 'Estado de Pago',
        noImages: 'No hay imágenes disponibles',
        noDocuments: 'No hay documentos disponibles',
        resendPODRequest: 'Reenviar Solicitud de POD',
        downloadReport: 'Descargar Informe',
        requestReason: 'Motivo de la Solicitud',
        selectReason: 'Seleccionar Motivo',
        selectReasonPlaceholder: 'Seleccionar tipo',
        customReason: 'Motivo Personalizado',
        customReasonPlaceholder: 'Escribe el motivo',
        submitCustomReason: 'Enviar motivo personalizado',
        submitRequest: 'Enviar',
        cancelRequest: 'Cancelar',
        podDownloaded: 'POD Descargado',
        successfully: 'Exitosamente',
        downloadSuccessMessage: 'El informe de POD y las imágenes se han descargado correctamente.',
        reasons: {
          incomplete_docs: 'Documentos Incompletos',
          blurry_image: 'Imagen Borrosa',
          other: 'Otro',
        },
      },

    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });

export default i18n;